import { useState, useEffect, useRef } from "react";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged } from "firebase/auth";
import { getFirestore, collection, addDoc, getDocs, doc, setDoc, deleteDoc, updateDoc, increment, orderBy, query, getDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA7UrSGqM_6EAlN1U0zxZKcvw0_oqLaBD0",
  authDomain: "airport-app-38845.firebaseapp.com",
  projectId: "airport-app-38845",
  storageBucket: "airport-app-38845.firebasestorage.app",
  messagingSenderId: "760674409728",
  appId: "1:760674409728:web:d7e41a2513c194ab7627e5",
  measurementId: "G-L64587XPDF"
};

const GOOGLE_MAPS_KEY = "AIzaSyB9OtOlIbosnRzgN0xJk1xSTFVJvFh4jAU";
const ANTHROPIC_KEY = "YOUR_KEY_HERE";
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const provider = new GoogleAuthProvider();

const AIRPORTS = [
  { id: "KPDX", name: "Portland Intl", lat: 45.5898, lon: -122.5951 },
  { id: "KTTD", name: "Portland Troutdale", lat: 45.5494, lon: -122.4014 },
  { id: "KHIO", name: "Hillsboro Airport", lat: 45.5404, lon: -122.9498 },
  { id: "KUAO", name: "Aurora State", lat: 45.2471, lon: -122.7698 },
  { id: "KSPB", name: "Scappoose Industrial", lat: 45.7708, lon: -122.8618 },
  { id: "KMMV", name: "McMinnville Municipal", lat: 45.1944, lon: -123.1363 },
  { id: "KSLE", name: "Salem McNary Field", lat: 44.9095, lon: -123.0029 },
  { id: "KEUG", name: "Eugene Airport", lat: 44.1246, lon: -123.2119 },
  { id: "KRDM", name: "Redmond Roberts Field", lat: 44.2541, lon: -121.1496 },
  { id: "KBNO", name: "Burns Municipal", lat: 43.5919, lon: -118.9552 },
  { id: "KLGD", name: "La Grande Union County", lat: 45.2902, lon: -118.0073 },
  { id: "KPDT", name: "Pendleton Airport", lat: 45.6951, lon: -118.8413 },
  { id: "KMFR", name: "Medford Rogue Valley Intl", lat: 42.3742, lon: -122.8735 },
  { id: "KOTH", name: "Southwest Oregon Regional", lat: 43.4171, lon: -124.2458 },
  { id: "KONP", name: "Newport Municipal", lat: 44.5804, lon: -124.0578 },
  { id: "KAST", name: "Astoria Regional", lat: 46.1580, lon: -123.8792 },
  { id: "KTMK", name: "Tillamook Airport", lat: 45.4182, lon: -123.8148 },
  { id: "KCVO", name: "Corvallis Municipal", lat: 44.4972, lon: -123.2903 },
  { id: "KRBG", name: "Roseburg Regional", lat: 43.2388, lon: -123.3568 },
  { id: "KLKV", name: "Lake County Airport", lat: 42.1611, lon: -120.3997 },
  { id: "KBOK", name: "Brookings Airport", lat: 42.0746, lon: -124.2897 },
  { id: "4S2", name: "Hood River Airport", lat: 45.6855, lon: -121.5249 },
  { id: "KDLS", name: "Columbia Gorge Regional", lat: 45.6185, lon: -121.1667 },
  { id: "KGCD", name: "Grant County Regional", lat: 44.3940, lon: -118.9633 },
  { id: "KBKE", name: "Baker City Municipal", lat: 44.8373, lon: -117.8088 },
  { id: "KLMT", name: "Klamath Falls Airport", lat: 42.1561, lon: -121.7332 },
  { id: "KONO", name: "Ontario Municipal", lat: 44.0205, lon: -117.0138 },
  { id: "KCZK", name: "Cascade Locks State", lat: 45.6782, lon: -121.8657 },
  { id: "KSEA", name: "Seattle-Tacoma Intl", lat: 47.4502, lon: -122.3088 },
  { id: "KBFI", name: "Boeing Field", lat: 47.5300, lon: -122.3020 },
  { id: "KRNT", name: "Renton Municipal", lat: 47.4931, lon: -122.2163 },
  { id: "KAWO", name: "Arlington Municipal", lat: 48.1607, lon: -122.1589 },
  { id: "KPWT", name: "Bremerton National", lat: 47.4902, lon: -122.7654 },
  { id: "KOLM", name: "Olympia Regional", lat: 46.9694, lon: -122.9029 },
  { id: "KTIW", name: "Tacoma Narrows", lat: 47.2679, lon: -122.5779 },
  { id: "KSHN", name: "Shelton Sanderson Field", lat: 47.2336, lon: -123.1483 },
  { id: "KHQM", name: "Bowerman Airport Hoquiam", lat: 46.9712, lon: -123.9369 },
  { id: "KPLU", name: "Pierce County Thun Field", lat: 47.1039, lon: -122.2870 },
  { id: "KPAE", name: "Paine Field Everett", lat: 47.9063, lon: -122.2815 },
  { id: "KBLI", name: "Bellingham Intl", lat: 48.7928, lon: -122.5375 },
  { id: "KFHR", name: "Friday Harbor Airport", lat: 48.5220, lon: -123.0243 },
  { id: "KORS", name: "Orcas Island Airport", lat: 48.7082, lon: -122.9100 },
  { id: "KCLM", name: "Port Angeles Fairchild Intl", lat: 48.1202, lon: -123.5003 },
  { id: "KKLS", name: "Southwest Washington Regional", lat: 46.1180, lon: -122.8983 },
  { id: "KVUO", name: "Pearson Field Vancouver", lat: 45.6206, lon: -122.6557 },
  { id: "KYKM", name: "Yakima Air Terminal", lat: 46.5682, lon: -120.5440 },
  { id: "KEAT", name: "Pangborn Memorial Wenatchee", lat: 47.3988, lon: -120.2074 },
  { id: "KOMK", name: "Omak Airport", lat: 48.4644, lon: -119.5177 },
  { id: "KGEG", name: "Spokane Intl", lat: 47.6199, lon: -117.5339 },
  { id: "KSFF", name: "Felts Field Spokane", lat: 47.6828, lon: -117.3229 },
  { id: "KPSC", name: "Tri-Cities Airport", lat: 46.2647, lon: -119.1190 },
  { id: "KALW", name: "Walla Walla Regional", lat: 46.0949, lon: -118.2887 },
  { id: "KELN", name: "Bowers Field Ellensburg", lat: 47.0330, lon: -120.5309 },
  { id: "KMWH", name: "Grant County Intl", lat: 47.2077, lon: -119.3202 },
  { id: "KCLS", name: "Chehalis Centralia Airport", lat: 46.6769, lon: -122.9834 },
  { id: "KPUW", name: "Pullman Moscow Regional", lat: 46.7439, lon: -117.1096 },
  { id: "KBVS", name: "Skagit Regional", lat: 48.4709, lon: -122.4201 },
  { id: "S18", name: "Forks Airport", lat: 47.9293, lon: -124.3955 },
  { id: "KSFO", name: "San Francisco Intl", lat: 37.6213, lon: -122.3790 },
  { id: "KLAX", name: "Los Angeles Intl", lat: 33.9425, lon: -118.4081 },
  { id: "KSAN", name: "San Diego Intl", lat: 32.7338, lon: -117.1933 },
  { id: "KSJC", name: "San Jose Intl", lat: 37.3626, lon: -121.9290 },
  { id: "KOAK", name: "Oakland Intl", lat: 37.7213, lon: -122.2208 },
  { id: "KSNA", name: "John Wayne Orange County", lat: 33.6757, lon: -117.8682 },
  { id: "KBUR", name: "Hollywood Burbank", lat: 34.2007, lon: -118.3585 },
  { id: "KLGB", name: "Long Beach Airport", lat: 33.8177, lon: -118.1516 },
  { id: "KONT", name: "Ontario Intl", lat: 34.0560, lon: -117.6012 },
  { id: "KSMF", name: "Sacramento Intl", lat: 38.6954, lon: -121.5908 },
  { id: "KFAT", name: "Fresno Yosemite Intl", lat: 36.7762, lon: -119.7182 },
  { id: "KSBP", name: "San Luis Obispo County", lat: 35.2368, lon: -120.6424 },
  { id: "KSBA", name: "Santa Barbara Municipal", lat: 34.4262, lon: -119.8404 },
  { id: "KMRY", name: "Monterey Regional", lat: 36.5870, lon: -121.8430 },
  { id: "KRDD", name: "Redding Municipal", lat: 40.5090, lon: -122.2930 },
  { id: "KACV", name: "California Redwood Coast", lat: 40.9781, lon: -124.1086 },
  { id: "KPSP", name: "Palm Springs Intl", lat: 33.8297, lon: -116.5067 },
  { id: "KTRK", name: "Truckee Tahoe Airport", lat: 39.3200, lon: -120.1400 },
  { id: "KCCR", name: "Buchanan Field Concord", lat: 37.9897, lon: -122.0569 },
  { id: "KRHV", name: "Reid Hillview San Jose", lat: 37.3329, lon: -121.8197 },
  { id: "KPAO", name: "Palo Alto Airport", lat: 37.4611, lon: -122.1148 },
  { id: "KSQL", name: "San Carlos Airport", lat: 37.5119, lon: -122.2497 },
  { id: "KHAF", name: "Half Moon Bay Airport", lat: 37.5134, lon: -122.5006 },
  { id: "KWVI", name: "Watsonville Municipal", lat: 36.9357, lon: -121.7902 },
  { id: "KSNS", name: "Salinas Municipal", lat: 36.6627, lon: -121.6063 },
  { id: "KMAE", name: "Madera Municipal", lat: 36.9886, lon: -120.1117 },
  { id: "KVIS", name: "Visalia Municipal", lat: 36.3187, lon: -119.3928 },
  { id: "KBFL", name: "Meadows Field Bakersfield", lat: 35.4336, lon: -119.0568 },
  { id: "KBIH", name: "Eastern Sierra Regional", lat: 37.3731, lon: -118.3635 },
  { id: "KMMD", name: "Merced Regional", lat: 37.2847, lon: -120.5138 },
  { id: "KMOD", name: "Modesto City County", lat: 37.6258, lon: -120.9544 },
  { id: "KSTS", name: "Charles M Schulz Sonoma County", lat: 38.5090, lon: -122.8127 },
  { id: "KUKI", name: "Ukiah Municipal", lat: 39.1259, lon: -123.2006 },
  { id: "KAPC", name: "Napa County Airport", lat: 38.2132, lon: -122.2806 },
  { id: "KLVK", name: "Livermore Municipal", lat: 37.6934, lon: -121.8197 },
  { id: "KTOA", name: "Torrance Municipal", lat: 33.8034, lon: -118.3396 },
  { id: "KPMD", name: "Palmdale Regional", lat: 34.6294, lon: -118.0846 },
  { id: "KCMA", name: "Camarillo Airport", lat: 34.2137, lon: -119.0944 },
  { id: "KOXR", name: "Oxnard Airport", lat: 34.2008, lon: -119.2072 },
  { id: "KCRQ", name: "McClellan-Palomar Airport", lat: 33.1283, lon: -117.2797 },
  { id: "KSEE", name: "Gillespie Field El Cajon", lat: 32.8262, lon: -116.9724 },
  { id: "KMYF", name: "Montgomery-Gibbs Executive", lat: 32.8158, lon: -117.1396 },
  { id: "KRNM", name: "Ramona Airport", lat: 33.0392, lon: -116.9152 },
  { id: "KLAS", name: "Harry Reid Intl Las Vegas", lat: 36.0840, lon: -115.1537 },
  { id: "KRNO", name: "Reno-Tahoe Intl", lat: 39.4991, lon: -119.7681 },
  { id: "KHND", name: "Henderson Executive", lat: 35.9728, lon: -115.1344 },
  { id: "KELY", name: "Ely Airport", lat: 39.2997, lon: -114.8416 },
  { id: "KTVL", name: "Lake Tahoe Airport", lat: 38.8939, lon: -119.9951 },
  { id: "KCXP", name: "Carson City Airport", lat: 39.1924, lon: -119.7341 },
  { id: "KWMC", name: "Winnemucca Municipal", lat: 40.8966, lon: -117.8059 },
  { id: "KPHX", name: "Phoenix Sky Harbor Intl", lat: 33.4373, lon: -112.0078 },
  { id: "KTUS", name: "Tucson Intl", lat: 32.1161, lon: -110.9410 },
  { id: "KFGZ", name: "Flagstaff Pulliam Airport", lat: 35.1385, lon: -111.6692 },
  { id: "KSDL", name: "Scottsdale Airport", lat: 33.6229, lon: -111.9111 },
  { id: "KIWA", name: "Phoenix Mesa Gateway", lat: 33.3078, lon: -111.6548 },
  { id: "KPRC", name: "Prescott Regional", lat: 34.6545, lon: -112.4198 },
  { id: "KYUM", name: "Yuma Intl", lat: 32.6566, lon: -114.6060 },
  { id: "KSOW", name: "Show Low Regional", lat: 34.2655, lon: -110.0056 },
  { id: "KGCN", name: "Grand Canyon National Park", lat: 35.9524, lon: -112.1470 },
  { id: "KSEZ", name: "Sedona Airport", lat: 34.8486, lon: -111.7885 },
  { id: "KDVT", name: "Phoenix Deer Valley", lat: 33.6883, lon: -112.0827 },
  { id: "KCHD", name: "Chandler Municipal", lat: 33.2692, lon: -111.8108 },
  { id: "KAVQ", name: "Marana Regional", lat: 32.4096, lon: -111.2185 },
  { id: "KBOI", name: "Boise Airport", lat: 43.5644, lon: -116.2228 },
  { id: "KIDA", name: "Idaho Falls Regional", lat: 43.5146, lon: -112.0708 },
  { id: "KPIH", name: "Pocatello Regional", lat: 42.9098, lon: -112.5960 },
  { id: "KSUN", name: "Friedman Memorial Hailey", lat: 43.5044, lon: -114.2963 },
  { id: "KLWS", name: "Lewiston Nez Perce County", lat: 46.3745, lon: -117.0153 },
  { id: "KCOE", name: "Coeur d Alene Airport", lat: 47.7743, lon: -116.8197 },
  { id: "KMYL", name: "McCall Municipal", lat: 44.8897, lon: -116.1006 },
  { id: "2ZT", name: "Sandpoint Airport", lat: 48.2995, lon: -116.5590 },
  { id: "KTWF", name: "Magic Valley Regional Twin Falls", lat: 42.4818, lon: -114.4878 },
  { id: "KEUL", name: "Caldwell Industrial", lat: 43.6415, lon: -116.6329 },
  { id: "KBZN", name: "Bozeman Yellowstone Intl", lat: 45.7777, lon: -111.1528 },
  { id: "KBIL", name: "Billings Logan Intl", lat: 45.8077, lon: -108.5428 },
  { id: "KGPI", name: "Glacier Park Intl", lat: 48.3105, lon: -114.2560 },
  { id: "KHLN", name: "Helena Regional", lat: 46.6068, lon: -111.9828 },
  { id: "KGTF", name: "Great Falls Intl", lat: 47.4820, lon: -111.3707 },
  { id: "KMSO", name: "Missoula Montana Airport", lat: 46.9163, lon: -114.0906 },
  { id: "KBTM", name: "Bert Mooney Butte", lat: 45.9548, lon: -112.4974 },
  { id: "KHVR", name: "Havre City County", lat: 48.5430, lon: -109.7622 },
  { id: "KMLS", name: "Miles City Airport", lat: 46.4280, lon: -105.8865 },
  { id: "KLWT", name: "Lewistown Municipal", lat: 47.0493, lon: -109.4670 },
  { id: "KSLC", name: "Salt Lake City Intl", lat: 40.7884, lon: -111.9778 },
  { id: "KOGD", name: "Ogden Hinckley Airport", lat: 41.1959, lon: -112.0122 },
  { id: "KPVU", name: "Provo Municipal", lat: 40.2192, lon: -111.7229 },
  { id: "KCDC", name: "Cedar City Regional", lat: 37.7010, lon: -113.0988 },
  { id: "KSTG", name: "St George Regional", lat: 37.0363, lon: -113.5103 },
  { id: "KCNY", name: "Moab Canyonlands Field", lat: 38.7550, lon: -109.7550 },
  { id: "KPGA", name: "Page Municipal", lat: 36.9261, lon: -111.4483 },
  { id: "KVEL", name: "Vernal Regional", lat: 40.4409, lon: -109.5100 },
  { id: "KDEN", name: "Denver Intl", lat: 39.8561, lon: -104.6737 },
  { id: "KCOS", name: "Colorado Springs Airport", lat: 38.8059, lon: -104.7009 },
  { id: "KGJT", name: "Grand Junction Regional", lat: 39.1224, lon: -108.5268 },
  { id: "KASE", name: "Aspen Pitkin County", lat: 39.2232, lon: -106.8687 },
  { id: "KEGE", name: "Eagle County Regional", lat: 39.6426, lon: -106.9177 },
  { id: "KDRO", name: "Durango La Plata County", lat: 37.1515, lon: -107.7539 },
  { id: "KPUB", name: "Pueblo Memorial Airport", lat: 38.2891, lon: -104.4967 },
  { id: "KGUC", name: "Gunnison Crested Butte Regional", lat: 38.5339, lon: -106.9330 },
  { id: "KMTJ", name: "Montrose Regional", lat: 38.5098, lon: -107.8938 },
  { id: "KFNL", name: "Northern Colorado Regional", lat: 40.4518, lon: -105.0113 },
  { id: "KAPA", name: "Centennial Airport Denver", lat: 39.5701, lon: -104.8490 },
  { id: "KALS", name: "San Luis Valley Regional", lat: 37.4349, lon: -105.8665 },
  { id: "KDFW", name: "Dallas Fort Worth Intl", lat: 32.8998, lon: -97.0403 },
  { id: "KIAH", name: "Houston George Bush Intl", lat: 29.9902, lon: -95.3368 },
  { id: "KAUS", name: "Austin Bergstrom Intl", lat: 30.1945, lon: -97.6699 },
  { id: "KSAT", name: "San Antonio Intl", lat: 29.5337, lon: -98.4698 },
  { id: "KELP", name: "El Paso Intl", lat: 31.8072, lon: -106.3779 },
  { id: "KHOU", name: "Houston Hobby Airport", lat: 29.6454, lon: -95.2789 },
  { id: "KDAL", name: "Dallas Love Field", lat: 32.8471, lon: -96.8518 },
  { id: "KAMA", name: "Rick Husband Amarillo Intl", lat: 35.2194, lon: -101.7059 },
  { id: "KLBB", name: "Lubbock Preston Smith Intl", lat: 33.6636, lon: -101.8228 },
  { id: "KMAF", name: "Midland Intl Air and Space", lat: 31.9425, lon: -102.2019 },
  { id: "KABI", name: "Abilene Regional", lat: 32.4113, lon: -99.6819 },
  { id: "KSJT", name: "San Angelo Regional", lat: 31.3577, lon: -100.4963 },
  { id: "KACT", name: "Waco Regional", lat: 31.6113, lon: -97.2305 },
  { id: "KTYR", name: "Tyler Pounds Regional", lat: 32.3541, lon: -95.4024 },
  { id: "KCLL", name: "Easterwood Field College Station", lat: 30.5886, lon: -96.3638 },
  { id: "KGRK", name: "Killeen Fort Cavazos Regional", lat: 30.7157, lon: -97.8291 },
  { id: "KGTU", name: "Georgetown Municipal", lat: 30.6788, lon: -97.6794 },
  { id: "KRBD", name: "Dallas Executive", lat: 32.6809, lon: -96.8682 },
  { id: "KMIA", name: "Miami Intl", lat: 25.7959, lon: -80.2870 },
  { id: "KMCO", name: "Orlando Intl", lat: 28.4294, lon: -81.3089 },
  { id: "KTPA", name: "Tampa Intl", lat: 27.9755, lon: -82.5332 },
  { id: "KFLL", name: "Fort Lauderdale Hollywood Intl", lat: 26.0726, lon: -80.1527 },
  { id: "KJAX", name: "Jacksonville Intl", lat: 30.4941, lon: -81.6879 },
  { id: "KPNS", name: "Pensacola Intl", lat: 30.4734, lon: -87.1866 },
  { id: "KTLH", name: "Tallahassee Intl", lat: 30.3965, lon: -84.3503 },
  { id: "KRSW", name: "Southwest Florida Intl", lat: 26.5362, lon: -81.7552 },
  { id: "KPBI", name: "Palm Beach Intl", lat: 26.6832, lon: -80.0956 },
  { id: "KSRQ", name: "Sarasota Bradenton Intl", lat: 27.3954, lon: -82.5544 },
  { id: "KAPF", name: "Naples Municipal", lat: 26.1526, lon: -81.7753 },
  { id: "KDAB", name: "Daytona Beach Intl", lat: 29.1799, lon: -81.0581 },
  { id: "KGNV", name: "Gainesville Regional", lat: 29.6900, lon: -82.2717 },
  { id: "KOCF", name: "Ocala International", lat: 29.1726, lon: -82.2241 },
  { id: "KATL", name: "Hartsfield Jackson Atlanta Intl", lat: 33.6407, lon: -84.4277 },
  { id: "KSAV", name: "Savannah Hilton Head Intl", lat: 32.1276, lon: -81.2021 },
  { id: "KAGS", name: "Augusta Regional", lat: 33.3699, lon: -81.9645 },
  { id: "KMCN", name: "Middle Georgia Regional", lat: 32.6928, lon: -83.6492 },
  { id: "KABY", name: "Southwest Georgia Regional", lat: 31.5355, lon: -84.1945 },
  { id: "KCSG", name: "Columbus Airport", lat: 32.5163, lon: -84.9389 },
  { id: "KVLD", name: "Valdosta Regional", lat: 30.7825, lon: -83.2767 },
  { id: "KPDK", name: "DeKalb Peachtree", lat: 33.8756, lon: -84.3020 },
  { id: "KFTY", name: "Fulton County Brown Field", lat: 33.7791, lon: -84.5214 },
  { id: "KCLT", name: "Charlotte Douglas Intl", lat: 35.2140, lon: -80.9431 },
  { id: "KRDU", name: "Raleigh Durham Intl", lat: 35.8776, lon: -78.7875 },
  { id: "KGSO", name: "Piedmont Triad Intl", lat: 36.0978, lon: -79.9373 },
  { id: "KAVL", name: "Asheville Regional", lat: 35.4362, lon: -82.5418 },
  { id: "KILM", name: "Wilmington Intl", lat: 34.2706, lon: -77.9026 },
  { id: "KFAY", name: "Fayetteville Regional", lat: 34.9912, lon: -78.8803 },
  { id: "KHKY", name: "Hickory Regional", lat: 35.7411, lon: -81.3895 },
  { id: "KCHS", name: "Charleston Intl", lat: 32.8986, lon: -80.0405 },
  { id: "KGSP", name: "Greenville Spartanburg Intl", lat: 34.8957, lon: -82.2189 },
  { id: "KMYR", name: "Myrtle Beach Intl", lat: 33.6797, lon: -78.9283 },
  { id: "KCAE", name: "Columbia Metropolitan", lat: 33.9388, lon: -81.1195 },
  { id: "KIAD", name: "Washington Dulles Intl", lat: 38.9445, lon: -77.4558 },
  { id: "KDCA", name: "Ronald Reagan Washington National", lat: 38.8521, lon: -77.0377 },
  { id: "KRIC", name: "Richmond Intl", lat: 37.5052, lon: -77.3197 },
  { id: "KORF", name: "Norfolk Intl", lat: 36.8976, lon: -76.0133 },
  { id: "KCHO", name: "Charlottesville Albemarle", lat: 38.1386, lon: -78.4529 },
  { id: "KROA", name: "Roanoke Blacksburg Regional", lat: 37.3255, lon: -79.9754 },
  { id: "KPHF", name: "Newport News Williamsburg Intl", lat: 37.1319, lon: -76.4930 },
  { id: "KBWI", name: "Baltimore Washington Intl", lat: 39.1754, lon: -76.6683 },
  { id: "KHGR", name: "Hagerstown Regional", lat: 39.7079, lon: -77.7295 },
  { id: "KSBY", name: "Salisbury Ocean City Regional", lat: 38.3405, lon: -75.5103 },
  { id: "KPHL", name: "Philadelphia Intl", lat: 39.8721, lon: -75.2411 },
  { id: "KPIT", name: "Pittsburgh Intl", lat: 40.4915, lon: -80.2329 },
  { id: "KMDT", name: "Harrisburg Intl", lat: 40.1935, lon: -76.7634 },
  { id: "KABE", name: "Lehigh Valley Intl", lat: 40.6521, lon: -75.4408 },
  { id: "KAVP", name: "Wilkes Barre Scranton Intl", lat: 41.3385, lon: -75.7234 },
  { id: "KERI", name: "Erie Intl", lat: 42.0831, lon: -80.1739 },
  { id: "KJFK", name: "John F Kennedy Intl", lat: 40.6413, lon: -73.7781 },
  { id: "KLGA", name: "LaGuardia Airport", lat: 40.7772, lon: -73.8726 },
  { id: "KEWR", name: "Newark Liberty Intl", lat: 40.6895, lon: -74.1745 },
  { id: "KBUF", name: "Buffalo Niagara Intl", lat: 42.9405, lon: -78.7322 },
  { id: "KSYR", name: "Syracuse Hancock Intl", lat: 43.1112, lon: -76.1063 },
  { id: "KALB", name: "Albany Intl", lat: 42.7483, lon: -73.8017 },
  { id: "KROC", name: "Greater Rochester Intl", lat: 43.1189, lon: -77.6724 },
  { id: "KITH", name: "Ithaca Tompkins Regional", lat: 42.4910, lon: -76.4584 },
  { id: "KSWF", name: "New York Stewart Intl", lat: 41.5041, lon: -74.1048 },
  { id: "KISP", name: "Long Island MacArthur", lat: 40.7952, lon: -73.1002 },
  { id: "KHPN", name: "Westchester County", lat: 41.0670, lon: -73.7076 },
  { id: "KBOS", name: "Boston Logan Intl", lat: 42.3656, lon: -71.0096 },
  { id: "KPWM", name: "Portland Intl Jetport Maine", lat: 43.6462, lon: -70.3093 },
  { id: "KBTV", name: "Burlington Intl Vermont", lat: 44.4720, lon: -73.1533 },
  { id: "KBDL", name: "Bradley Intl Connecticut", lat: 41.9389, lon: -72.6832 },
  { id: "KPVD", name: "TF Green Providence", lat: 41.7272, lon: -71.4282 },
  { id: "KMHT", name: "Manchester Boston Regional", lat: 42.9326, lon: -71.4357 },
  { id: "KBGR", name: "Bangor Intl", lat: 44.8074, lon: -68.8281 },
  { id: "KORH", name: "Worcester Regional", lat: 42.2673, lon: -71.8757 },
  { id: "KACK", name: "Nantucket Memorial", lat: 41.2531, lon: -70.0602 },
  { id: "KMVY", name: "Marthas Vineyard", lat: 41.3931, lon: -70.6143 },
  { id: "KHYA", name: "Barnstable Municipal Hyannis", lat: 41.6693, lon: -70.2804 },
  { id: "KDTW", name: "Detroit Metropolitan Wayne County", lat: 42.2124, lon: -83.3534 },
  { id: "KGRR", name: "Gerald R Ford Intl Grand Rapids", lat: 42.8808, lon: -85.5228 },
  { id: "KLAN", name: "Capital Region Intl Lansing", lat: 42.7787, lon: -84.5874 },
  { id: "KFNT", name: "Bishop Intl Flint", lat: 42.9654, lon: -83.7436 },
  { id: "KKAL", name: "Kalamazoo Battle Creek Intl", lat: 42.2349, lon: -85.5521 },
  { id: "KTVC", name: "Cherry Capital Traverse City", lat: 44.7414, lon: -85.5822 },
  { id: "KSAW", name: "Sawyer Intl Marquette", lat: 46.3536, lon: -87.3954 },
  { id: "KCMH", name: "John Glenn Columbus Intl", lat: 39.9980, lon: -82.8919 },
  { id: "KCLE", name: "Cleveland Hopkins Intl", lat: 41.4117, lon: -81.8498 },
  { id: "KCVG", name: "Cincinnati Northern Kentucky Intl", lat: 39.0488, lon: -84.6678 },
  { id: "KTOL", name: "Toledo Express Airport", lat: 41.5868, lon: -83.8078 },
  { id: "KDAY", name: "Dayton Intl", lat: 39.9024, lon: -84.2194 },
  { id: "KCAK", name: "Akron Canton Regional", lat: 40.9161, lon: -81.4422 },
  { id: "KYNG", name: "Youngstown Warren Regional", lat: 41.2607, lon: -80.6791 },
  { id: "KORD", name: "Chicago O Hare Intl", lat: 41.9742, lon: -87.9073 },
  { id: "KMDW", name: "Chicago Midway Intl", lat: 41.7868, lon: -87.7524 },
  { id: "KPIA", name: "General Downing Peoria Intl", lat: 40.6642, lon: -89.6933 },
  { id: "KRFD", name: "Chicago Rockford Intl", lat: 42.1954, lon: -89.0972 },
  { id: "KSPI", name: "Abraham Lincoln Capital Springfield", lat: 39.8441, lon: -89.6779 },
  { id: "KCMI", name: "University of Illinois Willard", lat: 40.0392, lon: -88.2782 },
  { id: "KDPA", name: "DuPage Airport", lat: 41.9078, lon: -88.2486 },
  { id: "KIND", name: "Indianapolis Intl", lat: 39.7173, lon: -86.2944 },
  { id: "KSBN", name: "South Bend Intl", lat: 41.7087, lon: -86.3173 },
  { id: "KFWA", name: "Fort Wayne Intl", lat: 40.9785, lon: -85.1951 },
  { id: "KEVV", name: "Evansville Regional", lat: 38.0369, lon: -87.5324 },
  { id: "KMKE", name: "Milwaukee Mitchell Intl", lat: 42.9472, lon: -87.8966 },
  { id: "KMSN", name: "Dane County Regional Madison", lat: 43.1399, lon: -89.3375 },
  { id: "KGRB", name: "Green Bay Austin Straubel Intl", lat: 44.4851, lon: -88.1296 },
  { id: "KEAU", name: "Chippewa Valley Regional Eau Claire", lat: 44.8658, lon: -91.4843 },
  { id: "KLSE", name: "La Crosse Regional", lat: 43.8790, lon: -91.2567 },
  { id: "KATW", name: "Appleton Intl", lat: 44.2581, lon: -88.5191 },
  { id: "KMSP", name: "Minneapolis Saint Paul Intl", lat: 44.8820, lon: -93.2218 },
  { id: "KDLH", name: "Duluth Intl", lat: 46.8421, lon: -92.1936 },
  { id: "KRST", name: "Rochester Intl Minnesota", lat: 43.9083, lon: -92.5000 },
  { id: "KSTC", name: "St Cloud Regional", lat: 45.5466, lon: -94.0599 },
  { id: "KBRD", name: "Brainerd Lakes Regional", lat: 46.3983, lon: -94.1381 },
  { id: "KSTL", name: "St Louis Lambert Intl", lat: 38.7487, lon: -90.3700 },
  { id: "KMCI", name: "Kansas City Intl", lat: 39.2976, lon: -94.7139 },
  { id: "KSGF", name: "Springfield Branson National", lat: 37.2457, lon: -93.3886 },
  { id: "KJLN", name: "Joplin Regional", lat: 37.1518, lon: -94.4983 },
  { id: "KCOU", name: "Columbia Regional", lat: 38.8181, lon: -92.2196 },
  { id: "KBNA", name: "Nashville Intl", lat: 36.1245, lon: -86.6782 },
  { id: "KMEM", name: "Memphis Intl", lat: 35.0424, lon: -89.9767 },
  { id: "KTYS", name: "McGhee Tyson Knoxville", lat: 35.8110, lon: -83.9940 },
  { id: "KCHA", name: "Chattanooga Metropolitan", lat: 35.0353, lon: -85.2038 },
  { id: "KTRI", name: "Tri Cities Regional", lat: 36.4752, lon: -82.4074 },
  { id: "KSDF", name: "Louisville Muhammad Ali Intl", lat: 38.1744, lon: -85.7360 },
  { id: "KLEX", name: "Blue Grass Airport Lexington", lat: 38.0365, lon: -84.6059 },
  { id: "KPAH", name: "Barkley Regional Paducah", lat: 37.0603, lon: -88.7738 },
  { id: "KBHM", name: "Birmingham Shuttlesworth Intl", lat: 33.5629, lon: -86.7535 },
  { id: "KHSV", name: "Huntsville Intl", lat: 34.6372, lon: -86.7751 },
  { id: "KMOB", name: "Mobile Regional Airport", lat: 30.6912, lon: -88.2428 },
  { id: "KMGM", name: "Montgomery Regional", lat: 32.3006, lon: -86.3940 },
  { id: "KDHN", name: "Dothan Regional", lat: 31.3213, lon: -85.4496 },
  { id: "KJAN", name: "Jackson Medgar Wiley Evers Intl", lat: 32.3112, lon: -90.0759 },
  { id: "KGPT", name: "Gulfport Biloxi Intl", lat: 30.4073, lon: -89.0701 },
  { id: "KGTR", name: "Golden Triangle Regional", lat: 33.4503, lon: -88.5914 },
  { id: "KMSY", name: "Louis Armstrong New Orleans Intl", lat: 29.9934, lon: -90.2580 },
  { id: "KBTR", name: "Baton Rouge Metro Ryan Field", lat: 30.5332, lon: -91.1496 },
  { id: "KSHV", name: "Shreveport Regional", lat: 32.4466, lon: -93.8256 },
  { id: "KLFT", name: "Lafayette Regional", lat: 30.2053, lon: -91.9876 },
  { id: "KALX", name: "Alexandria Intl", lat: 31.3274, lon: -92.5498 },
  { id: "KLIT", name: "Bill and Hillary Clinton National", lat: 34.7294, lon: -92.2243 },
  { id: "KFYV", name: "Drake Field Fayetteville", lat: 36.0051, lon: -94.1701 },
  { id: "KFSM", name: "Fort Smith Regional", lat: 35.3366, lon: -94.3674 },
  { id: "KOKC", name: "Will Rogers World Oklahoma City", lat: 35.3931, lon: -97.6007 },
  { id: "KTUL", name: "Tulsa Intl", lat: 36.1984, lon: -95.8881 },
  { id: "KLAW", name: "Lawton Fort Sill Regional", lat: 34.5677, lon: -98.4166 },
  { id: "KICT", name: "Wichita Dwight D Eisenhower National", lat: 37.6499, lon: -97.4331 },
  { id: "KMHK", name: "Manhattan Regional Kansas", lat: 39.1410, lon: -96.6708 },
  { id: "KTOP", name: "Philip Billard Municipal Topeka", lat: 39.0687, lon: -95.6225 },
  { id: "KDDC", name: "Dodge City Regional", lat: 37.7634, lon: -99.9655 },
  { id: "KOMA", name: "Eppley Airfield Omaha", lat: 41.3032, lon: -95.8941 },
  { id: "KLNK", name: "Lincoln Airport Nebraska", lat: 40.8510, lon: -96.7592 },
  { id: "KGRI", name: "Central Nebraska Regional Grand Island", lat: 40.9675, lon: -98.3096 },
  { id: "KBFF", name: "Scottsbluff Western Nebraska Regional", lat: 41.8740, lon: -103.5963 },
  { id: "KDSM", name: "Des Moines Intl", lat: 41.5340, lon: -93.6631 },
  { id: "KCID", name: "The Eastern Iowa Airport", lat: 41.8847, lon: -91.7108 },
  { id: "KSUX", name: "Sioux Gateway Sioux City", lat: 42.4026, lon: -96.3844 },
  { id: "KDBQ", name: "Dubuque Regional", lat: 42.4020, lon: -90.7095 },
  { id: "KFSD", name: "Sioux Falls Regional", lat: 43.5820, lon: -96.7419 },
  { id: "KRAP", name: "Rapid City Regional", lat: 44.0453, lon: -103.0574 },
  { id: "KABR", name: "Aberdeen Regional", lat: 45.4491, lon: -98.4218 },
  { id: "KPIR", name: "Pierre Regional", lat: 44.3827, lon: -100.2861 },
  { id: "KBIS", name: "Bismarck Airport", lat: 46.7727, lon: -100.7467 },
  { id: "KFAR", name: "Hector Intl Fargo", lat: 46.9207, lon: -96.8158 },
  { id: "KGFK", name: "Grand Forks Intl", lat: 47.9493, lon: -97.1761 },
  { id: "KMIB", name: "Minot Intl", lat: 48.2594, lon: -101.2781 },
  { id: "KCPR", name: "Casper Natrona County Intl", lat: 42.9080, lon: -106.4645 },
  { id: "KJAC", name: "Jackson Hole Airport", lat: 43.6073, lon: -110.7377 },
  { id: "KCYS", name: "Cheyenne Regional Jerry Olson Field", lat: 41.1557, lon: -104.8119 },
  { id: "KRKS", name: "Southwest Wyoming Regional", lat: 41.5942, lon: -109.0652 },
  { id: "KGCC", name: "Gillette Campbell County", lat: 44.3489, lon: -105.5394 },
  { id: "KSHR", name: "Sheridan County Airport", lat: 44.7692, lon: -106.9803 },
  { id: "KRIW", name: "Riverton Regional", lat: 43.0642, lon: -108.4596 },
  { id: "KABQ", name: "Albuquerque Intl Sunport", lat: 35.0402, lon: -106.6090 },
  { id: "KSAF", name: "Santa Fe Municipal", lat: 35.6170, lon: -106.0882 },
  { id: "KROW", name: "Roswell Intl Air Center", lat: 33.3016, lon: -104.5306 },
  { id: "KFMN", name: "Farmington Four Corners Regional", lat: 36.7412, lon: -108.2299 },
  { id: "KLRU", name: "Las Cruces International", lat: 32.2894, lon: -106.9219 },
  { id: "KSRR", name: "Sierra Blanca Regional Ruidoso", lat: 33.4628, lon: -105.5353 },
  { id: "PHNL", name: "Daniel K Inouye Intl Honolulu", lat: 21.3187, lon: -157.9224 },
  { id: "PHOG", name: "Kahului Airport Maui", lat: 20.8986, lon: -156.4305 },
  { id: "PHKO", name: "Ellison Onizuka Kona Intl", lat: 19.7388, lon: -156.0456 },
  { id: "PHLI", name: "Lihue Airport Kauai", lat: 21.9760, lon: -159.3390 },
  { id: "PHJH", name: "Kapalua Airport Maui", lat: 20.9629, lon: -156.6730 },
  { id: "PANC", name: "Ted Stevens Anchorage Intl", lat: 61.1744, lon: -149.9964 },
  { id: "PAFB", name: "Fairbanks Intl", lat: 64.8151, lon: -147.8561 },
  { id: "PAJN", name: "Juneau Intl", lat: 58.3550, lon: -134.5763 },
  { id: "PAKN", name: "King Salmon Airport", lat: 58.6768, lon: -156.6493 },
  { id: "PADQ", name: "Kodiak Airport", lat: 57.7500, lon: -152.4938 },
  { id: "PABE", name: "Bethel Airport", lat: 60.7798, lon: -161.8380 },
  { id: "PAOM", name: "Nome Airport", lat: 64.5122, lon: -165.4453 },
  { id: "PABR", name: "Wiley Post Will Rogers Barrow", lat: 71.2854, lon: -156.7661 },
  { id: "PFKO", name: "Ketchikan Intl", lat: 55.3556, lon: -131.7137 },
  { id: "PASI", name: "Sitka Rocky Gutierrez", lat: 57.0471, lon: -135.3617 },
  { id: "38W", name: "Lynden Airport", lat: 48.9559, lon: -122.458 },
  { id: "PAVD", name: "Valdez Pioneer Field", lat: 61.1339, lon: -146.2482 },

  // ── Small GA: Washington ──────────────────────────────
  { id: "W33", name: "Friday Harbor Seaplane Base", lat: 48.5373, lon: -123.01 },
  { id: "KS50", name: "Auburn Municipal Airport", lat: 47.3277, lon: -122.227 },
  { id: "S43", name: "Harvey Field", lat: 47.9082, lon: -122.105 },
  { id: "K74S", name: "Anacortes Airport", lat: 48.4985, lon: -122.6625 },
  { id: "KS97", name: "Anderson Field", lat: 48.1049, lon: -119.721 },
  { id: "1W1", name: "Grove Field", lat: 45.6278, lon: -122.404 },
  { id: "8S2", name: "Cashmere-Dryden Airport", lat: 47.5147, lon: -120.485 },
  { id: "KS10", name: "Lake Chelan Airport", lat: 47.866, lon: -119.943 },
  { id: "S93", name: "Cle Elum Municipal Airport", lat: 47.1943, lon: -120.883 },
  { id: "KS94", name: "Port of Whitman Business Air Center", lat: 46.8587, lon: -117.414 },
  { id: "63S", name: "Colville Municipal Airport", lat: 48.5439, lon: -117.884 },
  { id: "K68S", name: "Davenport Municipal Airport", lat: 47.6521, lon: -118.1738 },
  { id: "KDEW", name: "Deer Park Airport", lat: 47.9666, lon: -117.427 },
  { id: "K3W7", name: "Grand Coulee Dam Airport", lat: 47.922, lon: -119.083 },
  { id: "KEPH", name: "Ephrata Municipal Airport", lat: 47.3076, lon: -119.516 },
  { id: "KS23", name: "Ione Municipal Airport", lat: 48.7081, lon: -117.413 },
  { id: "S60", name: "Kenmore Air Harbor Seaplane Base", lat: 47.7548, lon: -122.259 },
  { id: "W10", name: "Whidbey Air Park", lat: 48.0175, lon: -122.438 },
  { id: "S31", name: "Lopez Island Airport", lat: 48.4839, lon: -122.938 },
  { id: "W04", name: "Ocean Shores Municipal Airport", lat: 46.9993, lon: -124.1424 },
  { id: "K43D", name: "Odessa Municipal Airport", lat: 47.3476, lon: -118.677 },
  { id: "K0S7", name: "Dorothy Scott Airport", lat: 48.959, lon: -119.412 },
  { id: "KS70", name: "Othello Municipal Airport", lat: 46.7949, lon: -119.079 },
  { id: "55S", name: "Packwood Airport", lat: 46.6042, lon: -121.678 },
  { id: "K0S9", name: "Jefferson County Intl Port Townsend", lat: 48.0538, lon: -122.811 },
  { id: "KS40", name: "Prosser Airport", lat: 46.2134, lon: -119.791 },
  { id: "KUIL", name: "Quillayute Airport", lat: 47.9366, lon: -124.563 },
  { id: "KRLD", name: "Richland Airport", lat: 46.3056, lon: -119.304 },
  { id: "K33S", name: "Pru Field Ritzville", lat: 47.1232, lon: -118.39 },
  { id: "72S", name: "Rosalia Municipal Airport", lat: 47.2366, lon: -117.4214 },
  { id: "K1S5", name: "Sunnyside Municipal Airport", lat: 46.3271, lon: -119.97 },
  { id: "KTDO", name: "South Lewis County Airport", lat: 46.4772, lon: -122.806 },
  { id: "2S1", name: "Vashon Municipal Airport", lat: 47.4586, lon: -122.474 },
  { id: "K2S8", name: "Wilbur Airport", lat: 47.7542, lon: -118.743 },
  { id: "KS52", name: "Methow Valley State Airport", lat: 48.4249, lon: -120.146 },

  // ── Small GA: Oregon ──────────────────────────────
  { id: "KS12", name: "Albany Municipal Airport", lat: 44.6378, lon: -123.059 },
  { id: "KS03", name: "Ashland Municipal Sumner Parker Field", lat: 42.1903, lon: -122.6606 },
  { id: "KBDN", name: "Bend Municipal Airport", lat: 44.0948, lon: -121.201 },
  { id: "KM50", name: "Boardman Airport", lat: 45.8148, lon: -119.821 },
  { id: "KS05", name: "Bandon State Airport", lat: 43.0865, lon: -124.408 },
  { id: "K3S4", name: "Illinois Valley Airport", lat: 42.1037, lon: -123.682 },
  { id: "K2S7", name: "Chiloquin State Airport", lat: 42.5794, lon: -121.8791 },
  { id: "K62S", name: "Christmas Valley Airport", lat: 43.2362, lon: -120.6651 },
  { id: "K3S9", name: "Condon State Pauling Field", lat: 45.2466, lon: -120.166 },
  { id: "K61S", name: "Cottage Grove State Airport", lat: 43.7998, lon: -123.029 },
  { id: "K77S", name: "Hobby Field Creswell", lat: 43.9308, lon: -123.007 },
  { id: "K6S2", name: "Florence Municipal Airport", lat: 43.9828, lon: -124.111 },
  { id: "KS45", name: "Siletz Bay State Airport", lat: 44.8769, lon: -124.029 },
  { id: "K4S1", name: "Gold Beach Municipal Airport", lat: 42.4134, lon: -124.424 },
  { id: "K3S8", name: "Grants Pass Airport", lat: 42.5101, lon: -123.388 },
  { id: "KHRI", name: "Hermiston Municipal Airport", lat: 45.8282, lon: -119.259 },
  { id: "K4S2", name: "Hood River Ken Jernstedt Airfield", lat: 45.6726, lon: -121.536 },
  { id: "K7S5", name: "Independence State Airport", lat: 44.867, lon: -123.198 },
  { id: "K4S3", name: "Joseph State Airport", lat: 45.3596, lon: -117.254 },
  { id: "S30", name: "Lebanon State Airport", lat: 44.5298, lon: -122.93 },
  { id: "K9S9", name: "Lexington Airport", lat: 45.4541, lon: -119.69 },
  { id: "KS33", name: "Madras Municipal Airport", lat: 44.6702, lon: -121.155 },
  { id: "K26U", name: "McDermitt State Airport", lat: 42.0095, lon: -117.7273 },
  { id: "16S", name: "Myrtle Creek Municipal Airport", lat: 42.9972, lon: -123.3154 },
  { id: "K4S9", name: "Mulino State Airport", lat: 45.2163, lon: -122.59 },
  { id: "KS39", name: "Prineville Airport", lat: 44.287, lon: -120.904 },
  { id: "56S", name: "Seaside Municipal Airport", lat: 46.0165, lon: -123.905 },
  { id: "K35S", name: "Wasco State Airport", lat: 45.5894, lon: -120.674 },

  // ── Small GA: Idaho ──────────────────────────────
  { id: "KU36", name: "Aberdeen Municipal Airport", lat: 42.921, lon: -112.881 },
  { id: "KAOC", name: "Arco Butte County Airport", lat: 43.6035, lon: -113.334 },
  { id: "KU02", name: "Mccarley Field Blackfoot", lat: 43.2092, lon: -112.3496 },
  { id: "K65S", name: "Boundary County Airport", lat: 48.7258, lon: -116.295 },
  { id: "KU03", name: "Buhl Municipal Airport", lat: 42.5916, lon: -114.797 },
  { id: "KBYI", name: "Burley Municipal Airport", lat: 42.5426, lon: -113.772 },
  { id: "KU70", name: "Cascade Airport", lat: 44.4938, lon: -116.016 },
  { id: "KLLJ", name: "Challis Airport", lat: 44.523, lon: -114.218 },
  { id: "KU82", name: "Council Municipal Airport", lat: 44.7503, lon: -116.4451 },
  { id: "KDIJ", name: "Driggs Reed Memorial Airport", lat: 43.7427, lon: -111.0968 },
  { id: "KGNG", name: "Gooding Municipal Airport", lat: 42.9172, lon: -114.765 },
  { id: "KGIC", name: "Idaho County Airport Grangeville", lat: 45.9426, lon: -116.123 },
  { id: "S66", name: "Homedale Municipal Airport", lat: 43.6149, lon: -116.922 },
  { id: "KJER", name: "Jerome County Airport", lat: 42.7267, lon: -114.457 },
  { id: "KS73", name: "Kamiah Municipal Airport", lat: 46.2193, lon: -116.013 },
  { id: "KS83", name: "Shoshone County Airport Kellogg", lat: 47.5473, lon: -116.1887 },
  { id: "KU76", name: "Mountain Home Municipal Airport", lat: 43.1313, lon: -115.73 },
  { id: "S68", name: "Orofino Municipal Airport", lat: 46.4913, lon: -116.277 },
  { id: "K1U7", name: "Bear Lake County Airport", lat: 42.2472, lon: -111.338 },
  { id: "KU10", name: "Preston Airport", lat: 42.1069, lon: -111.913 },
  { id: "1S6", name: "Priest River Municipal Airport", lat: 48.1906, lon: -116.9099 },
  { id: "KRXE", name: "Rexburg Madison County Airport", lat: 43.8339, lon: -111.805 },
  { id: "KS72", name: "St Maries Municipal Airport", lat: 47.3257, lon: -116.5765 },
  { id: "KSMN", name: "Lemhi County Airport Salmon", lat: 45.1222, lon: -113.882 },
  { id: "KS87", name: "Weiser Municipal Airport", lat: 44.2068, lon: -116.962 },
  // Idaho backcountry USFS strips
  { id: "U45", name: "Atlanta USFS Airport", lat: 43.9552, lon: -115.273 },
  { id: "52U", name: "Weatherby USFS Airport", lat: 43.8249, lon: -115.332 },
  { id: "U54", name: "Bernard USFS Airport", lat: 44.9796, lon: -114.735 },
  { id: "I08", name: "Cabin Creek USFS Airport", lat: 45.1435, lon: -114.929 },
  { id: "2ID7", name: "Cayuse Creek USFS Airport", lat: 46.6666, lon: -115.073 },
  { id: "U72", name: "Upper Loon Creek USFS Airport", lat: 44.5912, lon: -114.8248 },
  { id: "KU79", name: "Chamberlain USFS Airport", lat: 45.3733, lon: -115.1982 },
  { id: "KU81", name: "Cold Meadows USFS Airport", lat: 45.2948, lon: -114.9456 },
  { id: "A05", name: "Dixie USFS Airport", lat: 45.5189, lon: -115.5154 },
  { id: "ID76", name: "Wilson Bar USFS Airport", lat: 45.397, lon: -115.4853 },
  { id: "S92", name: "Fish Lake USFS Airport", lat: 46.33, lon: -115.063 },
  { id: "U98", name: "Idaho City USFS Airport", lat: 43.8237, lon: -115.8446 },
  { id: "S81", name: "Indian Creek USFS Airport", lat: 44.7613, lon: -115.107 },
  { id: "0U0", name: "Landmark USFS Airport", lat: 44.6424, lon: -115.533 },
  { id: "0U3", name: "Mahoney Creek USFS Airport", lat: 44.7446, lon: -114.9214 },
  { id: "24K", name: "Krassel USFS Airport", lat: 44.9743, lon: -115.73 },
  { id: "1U1", name: "Moose Creek USFS Airport", lat: 46.1243, lon: -114.9235 },
  { id: "67S", name: "Priest Lake USFS Airport", lat: 48.5749, lon: -116.964 },
  { id: "2U5", name: "Shearer USFS Airport", lat: 45.9916, lon: -114.841 },
  { id: "85U", name: "Soldier Bar USFS Airport", lat: 45.1045, lon: -114.7994 },
  { id: "3U1", name: "Warren USFS Airport", lat: 45.2678, lon: -115.6831 },

  // ── Small GA: Montana ──────────────────────────────
  { id: "K3U3", name: "Bowman Field Anaconda", lat: 46.1531, lon: -112.868 },
  { id: "KBHK", name: "Baker Municipal Airport", lat: 46.3466, lon: -104.2581 },
  { id: "K3U8", name: "Big Sandy Airport", lat: 48.1632, lon: -110.1157 },
  { id: "K6S0", name: "Big Timber Airport", lat: 45.8067, lon: -109.9792 },
  { id: "K00F", name: "Broadus Airport", lat: 45.4705, lon: -105.4571 },
  { id: "KLTY", name: "Liberty County Airport Chester", lat: 48.5107, lon: -110.991 },
  { id: "KS71", name: "Edgar G Obie Airport Chinook", lat: 48.5921, lon: -109.251 },
  { id: "KCII", name: "Choteau Airport", lat: 47.8283, lon: -112.168 },
  { id: "K4U6", name: "Circle Town County Airport", lat: 47.4186, lon: -105.562 },
  { id: "KM46", name: "Colstrip Airport", lat: 45.8529, lon: -106.709 },
  { id: "K6S3", name: "Woltermann Memorial Airport Columbus", lat: 45.6305, lon: -109.239 },
  { id: "KS01", name: "Conrad Airport", lat: 48.1686, lon: -111.976 },
  { id: "KS85", name: "Big Sky Field Culbertson", lat: 48.1533, lon: -104.504 },
  { id: "KCTB", name: "Cut Bank International Airport", lat: 48.6087, lon: -112.3782 },
  { id: "K38S", name: "Deer Lodge City County Airport", lat: 46.3882, lon: -112.766 },
  { id: "KDLN", name: "Dillon Airport", lat: 45.2554, lon: -112.553 },
  { id: "K97M", name: "Ekalaka Airport", lat: 45.8778, lon: -104.537 },
  { id: "KEKS", name: "Ennis Big Sky Airport", lat: 45.2718, lon: -111.649 },
  { id: "K88M", name: "Eureka Airport", lat: 48.9683, lon: -115.0795 },
  { id: "K1S3", name: "Tillitt Field Forsyth", lat: 46.2711, lon: -106.624 },
  { id: "K79S", name: "Fort Benton Airport", lat: 47.8451, lon: -110.636 },
  { id: "K29S", name: "Gardiner Airport", lat: 45.0499, lon: -110.747 },
  { id: "5U8", name: "Geraldine Airport", lat: 47.5965, lon: -110.2662 },
  { id: "KGDV", name: "Dawson Community Airport Glendive", lat: 47.1377, lon: -104.8069 },
  { id: "K6S5", name: "Ravalli County Airport Hamilton", lat: 46.2515, lon: -114.1256 },
  { id: "K48S", name: "Harlem Airport", lat: 48.5661, lon: -108.773 },
  { id: "KHWQ", name: "Wheatland County Airport Harlowton", lat: 46.4486, lon: -109.853 },
  { id: "KJDN", name: "Jordan Airport", lat: 47.3288, lon: -106.953 },
  { id: "KS27", name: "Kalispell City Airport", lat: 48.1786, lon: -114.304 },
  { id: "K6S8", name: "Laurel Municipal Airport", lat: 45.7031, lon: -108.761 },
  { id: "KS59", name: "Libby Airport", lat: 48.2838, lon: -115.49 },
  { id: "KS69", name: "Lincoln Airport", lat: 46.9544, lon: -112.65 },
  { id: "KLVM", name: "Mission Field Livingston", lat: 45.6994, lon: -110.448 },
  { id: "KM75", name: "Malta Airport", lat: 48.3669, lon: -107.919 },
  { id: "KU05", name: "Riddick Field Philipsburg", lat: 46.3194, lon: -113.305 },
  { id: "KS34", name: "Plains Airport", lat: 47.4735, lon: -114.9071 },
  { id: "KPWD", name: "Sher-Wood Airport Plentywood", lat: 48.7903, lon: -104.534 },
  { id: "K8S1", name: "Polson Airport", lat: 47.6954, lon: -114.185 },
  { id: "PO1", name: "Poplar Municipal Airport", lat: 48.1329, lon: -105.165 },
  { id: "KRED", name: "Red Lodge Airport", lat: 45.1846, lon: -109.2577 },
  { id: "K7S0", name: "Ronan Airport", lat: 47.5672, lon: -114.101 },
  { id: "KRPX", name: "Roundup Airport", lat: 46.4751, lon: -108.5415 },
  { id: "K9S2", name: "Scobey Airport", lat: 48.8076, lon: -105.4393 },
  { id: "KSBX", name: "Shelby Airport", lat: 48.5407, lon: -111.871 },
  { id: "KS64", name: "Stanford Airport Biggerstaff Field", lat: 47.1472, lon: -110.23 },
  { id: "K32S", name: "Stevensville Airport", lat: 46.5251, lon: -114.053 },
  { id: "K9S4", name: "Mineral County Airport Superior", lat: 47.1683, lon: -114.854 },
  { id: "K8U6", name: "Terry Airport", lat: 46.7771, lon: -105.3131 },
  { id: "KTHM", name: "Thompson Falls Airport", lat: 47.5735, lon: -115.281 },
  { id: "K9S5", name: "Three Forks Airport", lat: 45.8781, lon: -111.569 },
  { id: "K8U8", name: "Townsend Airport", lat: 46.3312, lon: -111.483 },
  { id: "K9U0", name: "Turner Airport", lat: 48.8542, lon: -108.409 },
  { id: "K7S7", name: "Valier Airport", lat: 48.2994, lon: -112.2492 },
  { id: "K7S6", name: "White Sulphur Springs Airport", lat: 46.5041, lon: -110.913 },
  { id: "9S7", name: "Winifred Airport", lat: 47.5554, lon: -109.386 },
  // Montana USFS strips
  { id: "S04", name: "Condon USFS Airport", lat: 47.5388, lon: -113.72 },
  { id: "0S1", name: "Meadow Creek USFS Airport", lat: 47.848, lon: -113.4168 },
  { id: "K8U2", name: "Schafer Meadows USFS Airport", lat: 48.0796, lon: -113.2433 },
  { id: "8U4", name: "Spotted Bear USFS Airport", lat: 47.962, lon: -113.5593 },
  { id: "38W", name: "Lynden Airport", lat: 48.9559, lon: -122.458 },
];

const TIME_OPTIONS = [
  { label: "45 min", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1.5 hours", value: 90 },
  { label: "2 hours", value: 120 },
  { label: "2.5 hours", value: 150 },
  { label: "3 hours", value: 180 },
];

const MEAL_TIME_OPTIONS = [
  { label: "30 min", value: 30 },
  { label: "45 min", value: 45 },
  { label: "1 hour", value: 60 },
  { label: "1.5 hours", value: 90 },
  { label: "2 hours", value: 120 },
];

const CUISINES = [
  { label: "Any", value: "any" },
  { label: "American", value: "american" },
  { label: "Mexican", value: "mexican" },
  { label: "Italian", value: "italian" },
  { label: "Asian", value: "asian" },
  { label: "Pizza", value: "pizza" },
  { label: "Seafood", value: "seafood" },
  { label: "Burgers", value: "burger" },
  { label: "Breakfast", value: "breakfast" },
  { label: "BBQ", value: "barbecue" },
  { label: "Chinese", value: "chinese" },
  { label: "Japanese", value: "japanese" },
  { label: "Thai", value: "thai" },
  { label: "Indian", value: "indian" },
  { label: "Mediterranean", value: "mediterranean" },
];

const SORT_OPTIONS = [
  { label: "Best fit", value: "score" },
  { label: "Closest", value: "distance" },
  { label: "Fastest drive", value: "drive" },
];

const CUISINE_ALIASES = {
  burger: ["burger", "hamburger", "smashburger", "five guys", "wendy", "mcdonald", "whataburger"],
  asian: ["asian", "chinese", "japanese", "thai", "korean", "vietnamese", "sushi", "ramen", "pho", "dim_sum"],
  american: ["american", "diner", "comfort", "grill", "pub", "tavern", "steakhouse"],
  barbecue: ["barbecue", "bbq", "smokehouse", "barbeque"],
  breakfast: ["breakfast", "brunch", "diner", "ihop", "waffle"],
  seafood: ["seafood", "fish", "crab", "lobster", "oyster", "shrimp"],
  mediterranean: ["mediterranean", "greek", "middle_eastern", "falafel", "hummus", "kebab"],
  pizza: ["pizza", "pizzeria", "italian"],
};

const NOTE_FILTERS = [
  { label: "Most recent", value: "recent" },
  { label: "Most liked", value: "likes" },
  { label: "Most relevant", value: "relevant" },
];

function haversine(lat1, lon1, lat2, lon2) {
  const R = 3958.8;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

function getNearestAirports(lat, lon, count = 5) {
  return AIRPORTS.map((airport) => ({
    ...airport,
    dist: haversine(lat, lon, airport.lat, airport.lon),
  }))
    .sort((a, b) => a.dist - b.dist)
    .slice(0, count);
}

function isRushHour() {
  const now = new Date();
  const day = now.getDay();
  const hour = now.getHours();
  if (day === 0 || day === 6) return false;
  return (hour >= 7 && hour < 9) || (hour >= 16 && hour < 19);
}

async function getRoutesAPI(fromLat, fromLon, toLat, toLon) {
  try {
    const res = await fetch(
      `https://routes.googleapis.com/directions/v2:computeRoutes`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": GOOGLE_MAPS_KEY,
          "X-Goog-FieldMask": "routes.duration,routes.distanceMeters",
        },
        body: JSON.stringify({
          origin: { location: { latLng: { latitude: fromLat, longitude: fromLon } } },
          destination: { location: { latLng: { latitude: toLat, longitude: toLon } } },
          travelMode: "DRIVE",
          routingPreference: "TRAFFIC_AWARE",
        }),
      }
    );
    const data = await res.json();
    if (data.routes && data.routes[0]) {
      const seconds = parseInt(data.routes[0].duration);
      const meters = data.routes[0].distanceMeters;
      return {
        driveMin: Math.round(seconds / 60),
        driveMiles: (meters / 1609.34).toFixed(1),
      };
    }
  } catch (e) {}
  return null;
}

function getAirportPhoto(airportLat, airportLon) {
  return `https://maps.googleapis.com/maps/api/staticmap?center=${airportLat},${airportLon}&zoom=14&size=600x300&maptype=satellite&markers=color:red%7Csize:small%7C${airportLat},${airportLon}&key=${GOOGLE_MAPS_KEY}`;
}

function scoreOption(place, availableMinutes, mealTime) {
  const buffer = availableMinutes - (place.driveMin * 2 + mealTime);
  let verdict;
  if (buffer >= 20) verdict = "SAFE";
  else if (buffer >= 5) verdict = "TIGHT";
  else verdict = "NO TIME";
  return { ...place, buffer, verdict, score: buffer * 0.6 };
}

async function fetchRestaurants(lat, lon, maxMiles) {
  const maxMeters = Math.round(maxMiles * 1609.34);
  try {
    const res = await fetch(
      `https://places.googleapis.com/v1/places:searchNearby`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Goog-Api-Key": GOOGLE_MAPS_KEY,
          "X-Goog-FieldMask": "places.displayName,places.location,places.primaryTypeDisplayName,places.types,places.regularOpeningHours,places.nationalPhoneNumber,places.websiteUri,places.googleMapsUri",
        },
        body: JSON.stringify({
          includedTypes: ["restaurant"],
          maxResultCount: 20,
          locationRestriction: {
            circle: {
              center: { latitude: lat, longitude: lon },
              radius: maxMeters,
            },
          },
        }),
      }
    );
    const data = await res.json();
    if (!data.places) return [];
    return data.places.map((p) => ({
      lat: p.location.latitude,
      lon: p.location.longitude,
      tags: {
        name: p.displayName?.text || "Unnamed restaurant",
        cuisine: p.primaryTypeDisplayName?.text || "",
        types: p.types || [],
        phone: p.nationalPhoneNumber || null,
        website: p.websiteUri || null,
        mapsUrl: p.googleMapsUri || null,
        hours: p.regularOpeningHours?.weekdayDescriptions || null,
        openNow: p.regularOpeningHours?.openNow ?? null,
      },
    }));
  } catch (e) {
    throw new Error("Could not fetch restaurants. Check your connection.");
  }
}

async function uploadPhoto(file, airportId, userId) {
  const safeName = file.name.replace(/[^a-zA-Z0-9.]/g, "_");
  const storageRef = ref(storage, `notes/${airportId}/${userId}_${Date.now()}_${safeName}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
}

async function aiTagCuisines(places) {
  const names = places.map(p => p.tags.name);
  const prompt = `These are restaurant names. For each one, identify the cuisine type. Return ONLY a valid JSON object mapping each name to one of these exact values: american, mexican, italian, asian, pizza, seafood, burger, breakfast, barbecue, chinese, japanese, thai, indian, mediterranean, or other. No explanation, no markdown, just JSON.

${names.map((n, i) => `${i + 1}. ${n}`).join('\n')}

Example format: {"Taco Bell": "mexican", "Sakura Garden": "japanese"}`;
  try {
    const response = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": ANTHROPIC_KEY,
        "anthropic-version": "2023-06-01",
        "anthropic-dangerous-direct-browser-access": "true",
      },
      body: JSON.stringify({
        model: "claude-sonnet-4-6",
        max_tokens: 1000,
        messages: [{ role: "user", content: prompt }]
      })
    });
    const data = await response.json();
    const text = data.content[0].text;
    const clean = text.replace(/```json|```/g, "").trim();
    return JSON.parse(clean);
  } catch (e) {
    return {};
  }
}

async function startCheckout(userId, email) {
  window.location.href = `https://buy.stripe.com/28EaEYc6F9eucyW3tM0Ba00?prefilled_email=${encodeURIComponent(email)}&client_reference_id=${userId}`;
}
const verdictColors = {
  SAFE: { background: "#d4edda", color: "#1a5c2a" },
  TIGHT: { background: "#fff3cd", color: "#7d4e00" },
  "NO TIME": { background: "#f8d7da", color: "#7b1c1c" },
};

/* eslint-disable no-unused-vars */
export default function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [user, setUser] = useState(null);
  const [isPro, setIsPro] = useState(true);
  const [authLoading, setAuthLoading] = useState(true);
  const [userLoc, setUserLoc] = useState(null);
  const [nearestAirport, setNearestAirport] = useState(null);
  const [nearbyAirports, setNearbyAirports] = useState([]);
  const [manualAirport, setManualAirport] = useState("");
  const [availableTime, setAvailableTime] = useState(90);
  const [mealTime, setMealTime] = useState(45);
  const [maxMiles, setMaxMiles] = useState(10);
  const [cuisineFilter, setCuisineFilter] = useState("any");
  const [sortBy, setSortBy] = useState("score");
  const [results, setResults] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [locFound, setLocFound] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [history, setHistory] = useState([]);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [noteFilter, setNoteFilter] = useState("recent");
  const [activeTab, setActiveTab] = useState("search");
  const [notesSubTab, setNotesSubTab] = useState("general");
  const [photoFile, setPhotoFile] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [uploadingPhoto, setUploadingPhoto] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [expandedReplies, setExpandedReplies] = useState({});
  const [noteReplies, setNoteReplies] = useState({});
  const [airportPhoto, setAirportPhoto] = useState(null);
  const [expandedResult, setExpandedResult] = useState(null);
  const [noRestaurants, setNoRestaurants] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const fileInputRef = useRef(null);

  const bg = darkMode ? "#0f1923" : "#f4f6fb";
  const cardBg = darkMode ? "#1a2535" : "white";
  const textPrimary = darkMode ? "#e8edf5" : "#0f2a4a";
  const textSecondary = darkMode ? "#7a90aa" : "#6b7a90";
  const borderColor = darkMode ? "#2a3a50" : "#e2e8f0";

  const s = {
    app: { maxWidth: 520, margin: "0 auto", padding: "1.5rem 1rem", fontFamily: "'Segoe UI', system-ui, sans-serif", background: bg, minHeight: "100vh", color: textPrimary, transition: "background 0.2s" },
    header: { background: "linear-gradient(135deg, #0f2a4a 0%, #1a4a7a 100%)", borderRadius: 16, padding: "1.25rem 1.5rem", marginBottom: 16, color: "white" },
    headerRow: { display: "flex", justifyContent: "space-between", alignItems: "flex-start" },
    headerTitle: { fontSize: 20, fontWeight: 700, color: "white", margin: 0 },
    headerSub: { fontSize: 12, color: "#a8c4e0", marginTop: 3 },
    darkBtn: { background: "transparent", border: "1px solid rgba(255,255,255,0.3)", borderRadius: 8, color: "white", fontSize: 12, padding: "4px 10px", cursor: "pointer" },
    card: { background: cardBg, borderRadius: 14, padding: "1rem 1.25rem", marginBottom: 12, border: `1px solid ${borderColor}` },
    label: { fontSize: 10, fontWeight: 700, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6, display: "block" },
    select: { width: "100%", padding: "9px 12px", borderRadius: 10, border: `1px solid ${borderColor}`, fontSize: 14, background: cardBg, color: textPrimary, outline: "none" },
    input: { width: "100%", padding: "9px 12px", borderRadius: 10, border: `1px solid ${borderColor}`, fontSize: 14, background: cardBg, color: textPrimary, outline: "none", boxSizing: "border-box" },
    row: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 },
    btnSecondary: { width: "100%", padding: "10px", marginBottom: 8, borderRadius: 10, border: `1.5px solid ${borderColor}`, background: cardBg, fontSize: 14, fontWeight: 600, color: textPrimary, cursor: "pointer" },
    btnPrimary: { width: "100%", padding: "12px", marginBottom: 16, borderRadius: 10, border: "none", background: "linear-gradient(135deg, #0f2a4a 0%, #1a4a7a 100%)", color: "white", fontSize: 15, fontWeight: 700, cursor: "pointer" },
    btnPro: { width: "100%", padding: "12px", marginBottom: 8, borderRadius: 10, border: "none", background: "linear-gradient(135deg, #b8860b 0%, #ffd700 100%)", color: "#1a1a00", fontSize: 15, fontWeight: 700, cursor: "pointer" },
    btnGoogle: { width: "100%", padding: "12px", marginBottom: 8, borderRadius: 10, border: "1.5px solid #e2e8f0", background: "white", fontSize: 14, fontWeight: 600, color: "#1a1a2e", cursor: "pointer" },
    btnSmall: { padding: "5px 12px", borderRadius: 8, border: `1px solid ${borderColor}`, background: cardBg, fontSize: 12, fontWeight: 600, color: textPrimary, cursor: "pointer" },
    btnDanger: { padding: "5px 12px", borderRadius: 8, border: "1px solid #f8d7da", background: "#f8d7da", fontSize: 12, fontWeight: 600, color: "#7b1c1c", cursor: "pointer" },
    btnLike: (liked) => ({ padding: "5px 12px", borderRadius: 8, border: liked ? "1px solid #1a4a7a" : `1px solid ${borderColor}`, background: liked ? "#e6f1fb" : cardBg, fontSize: 12, fontWeight: 600, color: liked ? "#1a4a7a" : textSecondary, cursor: "pointer" }),
    btnLink: { padding: "5px 12px", borderRadius: 8, border: "1px solid #1a4a7a", background: "#e6f1fb", fontSize: 12, fontWeight: 600, color: "#1a4a7a", cursor: "pointer", textDecoration: "none" },
    status: { fontSize: 13, color: textSecondary, marginBottom: 12, padding: "10px 14px", background: cardBg, borderRadius: 10, border: `1px solid ${borderColor}` },
    tabs: { display: "flex", gap: 6, marginBottom: 16 },
    tab: { flex: 1, padding: "9px", borderRadius: 10, border: `1px solid ${borderColor}`, background: cardBg, fontSize: 12, fontWeight: 600, color: textSecondary, cursor: "pointer", textAlign: "center" },
    tabActive: { background: "linear-gradient(135deg, #0f2a4a 0%, #1a4a7a 100%)", color: "white", border: "none" },
    subTabs: { display: "flex", gap: 6, marginBottom: 12 },
    subTab: { flex: 1, padding: "7px", borderRadius: 8, border: `1px solid ${borderColor}`, background: cardBg, fontSize: 12, fontWeight: 600, color: textSecondary, cursor: "pointer", textAlign: "center" },
    subTabActive: { background: "#1a4a7a", color: "white", border: "none" },
    resultCard: { background: cardBg, borderRadius: 14, padding: "1rem 1.25rem", marginBottom: 10, border: `1px solid ${borderColor}` },
    resultCardTop: { background: cardBg, borderRadius: 14, padding: "1rem 1.25rem", marginBottom: 10, border: "2px solid #1a4a7a" },
    statValue: { fontWeight: 700, fontSize: 15, color: textPrimary, display: "block", marginBottom: 2 },
    statLabel: { fontSize: 11, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.05em" },
    statsRow: { display: "flex", gap: 20, marginTop: 10, paddingTop: 10, borderTop: `1px solid ${borderColor}` },
    actionRow: { display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" },
    rush: { background: "#fff3cd", color: "#7d4e00", borderRadius: 10, padding: "8px 14px", fontSize: 13, fontWeight: 600, marginBottom: 12 },
    proWall: { background: cardBg, borderRadius: 14, padding: "2rem 1.5rem", marginBottom: 12, border: `1px solid ${borderColor}`, textAlign: "center" },
    noteCard: { background: cardBg, borderRadius: 12, padding: "12px 14px", marginBottom: 10, border: `1px solid ${borderColor}` },
    noteMeta: { fontSize: 11, color: textSecondary, marginBottom: 4 },
    noteText: { fontSize: 14, color: textPrimary, marginBottom: 8 },
    notePhoto: { width: "100%", borderRadius: 10, marginBottom: 8, maxHeight: 200, objectFit: "cover" },
    noteActions: { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" },
    replyCard: { background: darkMode ? "#0f1923" : "#f8fafc", borderRadius: 10, padding: "10px 12px", marginTop: 8, border: `1px solid ${borderColor}` },
    replyMeta: { fontSize: 11, color: textSecondary, marginBottom: 3 },
    replyText: { fontSize: 13, color: textPrimary },
    historyItem: { background: cardBg, borderRadius: 10, padding: "10px 14px", marginBottom: 8, border: `1px solid ${borderColor}`, display: "flex", justifyContent: "space-between", alignItems: "center" },
    userRow: { display: "flex", alignItems: "center", gap: 10, marginTop: 10 },
    avatar: { width: 32, height: 32, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.4)" },
    airportImg: { width: "100%", borderRadius: 10, marginTop: 10, height: 180, objectFit: "cover", objectPosition: "center" },
    photoPreviewImg: { width: "100%", borderRadius: 10, marginBottom: 8, maxHeight: 150, objectFit: "cover" },
    fboCard: { background: darkMode ? "#0f1923" : "#f0f4f8", borderRadius: 10, padding: "10px 14px", marginTop: 10, border: `1px solid ${borderColor}` },
    openBadge: (open) => ({ display: "inline-block", fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 100, background: open ? "#d4edda" : "#f8d7da", color: open ? "#1a5c2a" : "#7b1c1c", marginLeft: 8 }),
    detailRow: { fontSize: 12, color: textSecondary, marginTop: 4 },
  };

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      setAuthLoading(false);
      if (u) {
        loadFavorites(u.uid);
        loadHistory(u.uid);
        const userDoc = await getDoc(doc(db, "users", u.uid));
        if (userDoc.exists()) setIsPro(userDoc.data().isPro === true);
      }
    });
    return unsub;
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("pro") === "success") {
      setStatus("Welcome to BlockTime Pro! Your subscription is now active.");
      window.history.replaceState({}, "", "/");
    }
  }, []);

  useEffect(() => {
    if (nearestAirport) {
      loadNotes(nearestAirport.id);
      const photo = getAirportPhoto(nearestAirport.lat, nearestAirport.lon);
      setAirportPhoto(photo);
    }
  }, [nearestAirport]);

  async function signInWithGoogle() {
    try { await signInWithPopup(auth, provider); }
    catch (e) { setStatus("Sign-in failed. Try again."); }
  }

  async function handleSignOut() {
    await signOut(auth);
    setFavorites([]);
    setHistory([]);
    setIsPro(false);
  }

  async function handleUpgrade() {
    if (!user) { setStatus("Sign in first to upgrade."); return; }
    setCheckoutLoading(true);
    try { await startCheckout(user.uid, user.email); }
    catch (e) { setStatus("Could not start checkout. Try again."); }
    setCheckoutLoading(false);
  }

  function ProWall({ feature }) {
    return (
      <div style={s.proWall}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>✈️</div>
        <div style={{ fontSize: 17, fontWeight: 700, color: textPrimary, marginBottom: 6 }}>BlockTime Pro</div>
        <div style={{ fontSize: 13, color: textSecondary, marginBottom: 20 }}>
          {feature} is a Pro feature. Upgrade for $4.99/month to unlock pilot notes, crew car info, FBO intel, and favorites.
        </div>
        {!user ? (
          <button style={s.btnGoogle} onClick={signInWithGoogle}>Sign in with Google to upgrade</button>
        ) : (
          <button style={s.btnPro} onClick={handleUpgrade} disabled={checkoutLoading}>
            {checkoutLoading ? "Loading..." : "Upgrade to Pro — $4.99/month"}
          </button>
        )}
        <div style={{ fontSize: 11, color: textSecondary, marginTop: 10 }}>Cancel anytime. No commitment.</div>
      </div>
    );
  }

  async function loadFavorites(uid) {
    try {
      const snap = await getDocs(collection(db, "users", uid, "favorites"));
      setFavorites(snap.docs.map((d) => d.data().name));
    } catch (e) {}
  }

  async function loadHistory(uid) {
    try {
      const snap = await getDocs(collection(db, "users", uid, "history"));
      const items = snap.docs.map((d) => d.data()).sort((a, b) => b.timestamp - a.timestamp).slice(0, 10);
      setHistory(items);
    } catch (e) {}
  }

  async function loadNotes(airportId) {
    try {
      const q = query(collection(db, "notes", airportId, "entries"), orderBy("timestamp", "desc"));
      const snap = await getDocs(q);
      setNotes(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    } catch (e) {}
  }

  async function loadReplies(airportId, noteId) {
    try {
      const snap = await getDocs(collection(db, "notes", airportId, "entries", noteId, "replies"));
      const replies = snap.docs.map((d) => ({ id: d.id, ...d.data() })).sort((a, b) => a.timestamp - b.timestamp);
      setNoteReplies((prev) => ({ ...prev, [noteId]: replies }));
    } catch (e) {}
  }

  async function toggleFavorite(name) {
    if (!isPro) { setActiveTab("favorites"); return; }
    if (!user) { setStatus("Sign in to save favorites."); return; }
    const isFav = favorites.includes(name);
    const ref2 = doc(db, "users", user.uid, "favorites", name);
    if (isFav) { await deleteDoc(ref2); setFavorites(favorites.filter((f) => f !== name)); }
    else { await setDoc(ref2, { name }); setFavorites([...favorites, name]); }
  }

  async function saveToHistory(airportId, count) {
    if (!user) return;
    const entry = { airport: airportId, results: count, timestamp: Date.now(), time: new Date().toLocaleString() };
    try {
      await addDoc(collection(db, "users", user.uid, "history"), entry);
      setHistory((prev) => [entry, ...prev].slice(0, 10));
    } catch (e) {}
  }

  async function likeNote(noteId) {
    if (!user) { setStatus("Sign in to like notes."); return; }
    const noteRef = doc(db, "notes", nearestAirport.id, "entries", noteId);
    const likeRef = doc(db, "notes", nearestAirport.id, "entries", noteId, "likes", user.uid);
    const existing = await getDoc(likeRef);
    if (existing.exists()) {
      await deleteDoc(likeRef);
      await updateDoc(noteRef, { likes: increment(-1) });
      setNotes(notes.map((n) => n.id === noteId ? { ...n, likes: (n.likes || 1) - 1, likedByMe: false } : n));
    } else {
      await setDoc(likeRef, { uid: user.uid });
      await updateDoc(noteRef, { likes: increment(1) });
      setNotes(notes.map((n) => n.id === noteId ? { ...n, likes: (n.likes || 0) + 1, likedByMe: true } : n));
    }
  }

  async function addReply(noteId) {
    if (!user || !replyText.trim()) return;
    const reply = { text: replyText.trim(), author: user.displayName || "Anonymous pilot", uid: user.uid, timestamp: Date.now(), time: new Date().toLocaleString() };
    try {
      await addDoc(collection(db, "notes", nearestAirport.id, "entries", noteId, "replies"), reply);
      setNoteReplies((prev) => ({ ...prev, [noteId]: [...(prev[noteId] || []), reply] }));
      setReplyText("");
      setReplyingTo(null);
    } catch (e) {}
  }

  async function reportNote(noteId) {
    if (!user) { setStatus("Sign in to report notes."); return; }
    try {
      await setDoc(doc(db, "reports", noteId), { noteId, reportedBy: user.uid, airport: nearestAirport.id, timestamp: Date.now() });
      setStatus("Note reported. Thank you.");
    } catch (e) {}
  }

  function handlePhotoSelect(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { setStatus("Please select an image file."); return; }
    if (file.size > 5 * 1024 * 1024) { setStatus("Photo must be under 5MB."); return; }
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  }

  async function addNote() {
    if (!user) { setStatus("Sign in to post notes."); return; }
    if (!isPro) { setStatus("BlockTime Pro required to post notes."); return; }
    if (!newNote.trim() && !photoFile) return;
    if (!nearestAirport) { setStatus("Select an airport first."); return; }
    setUploadingPhoto(true);
    let photoURL = null;
    if (photoFile) {
      try { photoURL = await uploadPhoto(photoFile, nearestAirport.id, user.uid); }
      catch (e) { setStatus("Photo upload failed. Try again."); setUploadingPhoto(false); return; }
    }
    const entry = { text: newNote.trim(), author: user.displayName || "Anonymous pilot", authorPhoto: user.photoURL || "", uid: user.uid, timestamp: Date.now(), time: new Date().toLocaleString(), photoURL: photoURL || null, likes: 0, type: notesSubTab };
    try {
      const ref2 = await addDoc(collection(db, "notes", nearestAirport.id, "entries"), entry);
      setNotes([{ id: ref2.id, ...entry }, ...notes]);
      setNewNote("");
      setPhotoFile(null);
      setPhotoPreview(null);
    } catch (e) { setStatus("Failed to post note. Try again."); }
    setUploadingPhoto(false);
  }

  async function deleteNote(noteId) {
    if (!nearestAirport) return;
    try { await deleteDoc(doc(db, "notes", nearestAirport.id, "entries", noteId)); setNotes(notes.filter((n) => n.id !== noteId)); }
    catch (e) {}
  }

  function detectLocation() {
    setStatus("Detecting location...");
    if (!navigator.geolocation) { setStatus("GPS not supported on this browser."); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        setUserLoc({ lat: latitude, lon: longitude });
        const nearest = getNearestAirports(latitude, longitude, 5);
        setNearbyAirports(nearest);
        setNearestAirport(nearest[0]);
        setLocFound(true);
        setStatus(`Found ${nearest.length} nearby airports — select yours below.`);
      },
      (err) => {
        if (err.code === 1) setStatus("Location denied. Go to Settings > Privacy > Location Services.");
        else if (err.code === 2) setStatus("Location unavailable. Try again outside.");
        else setStatus("Location timed out. Tap detect again.");
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }

  function handleManualAirport() {
    const id = manualAirport.toUpperCase().trim();
    const found = AIRPORTS.find((a) => a.id === id);
    if (found) {
      const foundWithDist = { ...found, dist: 0 };
      setNearestAirport(foundWithDist);
      setNearbyAirports([foundWithDist]);
      setLocFound(true);
      setUserLoc({ lat: found.lat, lon: found.lon });
      setStatus(`Airport set to ${found.id} — ${found.name}`);
      setResults([]);
      setManualAirport("");
    } else {
      setStatus(`Airport ${id} not found. Try the 4-letter ICAO code like KBZN.`);
    }
  }

  function shareResult(r) {
    const text = `${r.name} — ${r.driveMiles} mi, ${r.driveMin} min drive. Verdict: ${r.verdict}. Buffer: ${r.buffer} min. Via BlockTime: getblocktime.com`;
    if (navigator.share) navigator.share({ title: "BlockTime Pick", text });
    else { navigator.clipboard.writeText(text); setStatus("Copied to clipboard!"); }
  }

  function openInMaps(r) {
    const q = encodeURIComponent(r.name);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    window.open(isIOS ? `maps://maps.apple.com/?q=${q}` : `https://www.google.com/maps/search/?api=1&query=${q}`, "_blank");
  }

  function openGoogleMapsPage(r) {
    if (r.mapsUrl) window.open(r.mapsUrl, "_blank");
    else window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(r.name)}`, "_blank");
  }

  function getSortedResults() {
    const filtered = cuisineFilter === "any"
      ? results
      : results.filter((r) => {
          const c = cuisineFilter.toLowerCase();
          const cuisine = r.cuisine?.toLowerCase() || "";
          const name = r.name?.toLowerCase() || "";
          const types = (r.types || []).join(" ").toLowerCase();
          const haystack = `${cuisine} ${name} ${types}`;
          const terms = CUISINE_ALIASES[c] || [c];
return r.cuisine?.toLowerCase() === c || terms.some(term => haystack.includes(term));        });
    return [...filtered].sort((a, b) => {
      if (sortBy === "distance") return parseFloat(a.driveMiles) - parseFloat(b.driveMiles);
      if (sortBy === "drive") return a.driveMin - b.driveMin;
      return b.score - a.score;
    });
  }

  function getSortedNotes() {
    const filtered = notes.filter((n) => (n.type || "general") === notesSubTab);
    return [...filtered].sort((a, b) => {
      if (noteFilter === "likes") return (b.likes || 0) - (a.likes || 0);
      if (noteFilter === "relevant") return ((b.likes || 0) * 0.5 + b.timestamp * 0.0000001) - ((a.likes || 0) * 0.5 + a.timestamp * 0.0000001);
      return b.timestamp - a.timestamp;
    });
  }

  async function findOptions() {
    if (!userLoc) { setStatus("Detect your location first."); return; }
    if (!nearestAirport) { setStatus("Select an airport first."); return; }
    setLoading(true);
    setResults([]);
    setNoRestaurants(false);
    setStatus("Fetching nearby restaurants...");
    const searchLat = nearestAirport.lat;
    const searchLon = nearestAirport.lon;
    try {
      const rawPlaces = await fetchRestaurants(searchLat, searchLon, maxMiles);
      const places = rawPlaces.filter(p => {
        if (searchLat < 50 && p.lat > 49.1) return false; // drop Canada results
        if (searchLat > 25 && searchLat < 32 && p.lat < 25.7) return false; // drop Mexico results
        return true;
      });
if (places.length === 0) { setNoRestaurants(true); setStatus(`No restaurants found within ${maxMiles} mi of ${nearestAirport.id}.`); setLoading(false); return; }      setStatus(`Found ${places.length} restaurants — identifying cuisines...`);
      const cuisineTags = await aiTagCuisines(places);
      setStatus(`Found ${places.length} restaurants — calculating drive times...`);
      const withRoutes = await Promise.all(
        places.slice(0, 12).map(async (p) => {
          const route = await getRoutesAPI(searchLat, searchLon, p.lat, p.lon);
          if (!route) return null;
          const aiCuisine = cuisineTags[p.tags?.name] || "";
          return scoreOption({ name: p.tags?.name || "Unnamed restaurant", cuisine: aiCuisine || p.tags?.cuisine || "", types: p.tags?.types || [], phone: p.tags?.phone || null, website: p.tags?.website || null, mapsUrl: p.tags?.mapsUrl || null, hours: p.tags?.hours || null, openNow: p.tags?.openNow ?? null, driveMin: route.driveMin, driveMiles: route.driveMiles }, availableTime, mealTime);
        })
      );
      const scored = withRoutes.filter(Boolean).sort((a, b) => b.score - a.score).slice(0, 10);
      setResults(scored);
      await saveToHistory(nearestAirport.id, scored.length);
      setStatus(`${scored.length} options found near ${nearestAirport.id}`);
    } catch (err) {
      setStatus(`Error: ${err.message}`);
    }
    setLoading(false);
  }

  const sortedResults = getSortedResults();
  const sortedNotes = getSortedNotes();

  if (authLoading) {
    return <div style={{ ...s.app, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ fontSize: 16, color: textSecondary }}>Loading...</div></div>;
  }

  return (
    <div style={s.app}>
      <div style={s.header}>
        <div style={s.headerRow}>
          <div>
            <p style={s.headerTitle}>BlockTime {isPro && <span style={{ fontSize: 11, background: "#ffd700", color: "#1a1a00", borderRadius: 6, padding: "2px 7px", marginLeft: 6, fontWeight: 700 }}>PRO</span>}</p>
            <p style={s.headerSub}>Real drive times · Pilot layover planner</p>
          </div>
          <button style={s.darkBtn} onClick={() => setDarkMode(!darkMode)}>{darkMode ? "Light" : "Dark"}</button>
        </div>
        {user ? (
          <div style={s.userRow}>
            {user.photoURL && <img src={user.photoURL} alt="avatar" style={s.avatar} />}
            <span style={{ fontSize: 13, color: "white", fontWeight: 600 }}>{user.displayName}</span>
            <button style={{ ...s.darkBtn, marginLeft: "auto" }} onClick={handleSignOut}>Sign out</button>
          </div>
        ) : (
          <button style={{ ...s.darkBtn, marginTop: 10, width: "100%" }} onClick={signInWithGoogle}>Sign in with Google</button>
        )}
      </div>

      <div style={s.tabs}>
        {["search", "notes", "history", "favorites"].map((tab) => (
          <button key={tab} style={{ ...s.tab, ...(activeTab === tab ? s.tabActive : {}) }} onClick={() => setActiveTab(tab)}>
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {activeTab === "search" && (
        <>
          {isRushHour() && <div style={s.rush}>Rush hour detected — add 10-15 min to drive estimates</div>}

          {locFound && nearbyAirports.length > 0 && (
            <div style={s.card}>
              <label style={s.label}>Select your airport</label>
              <select value={nearestAirport?.id || ""} onChange={(e) => { const sel = nearbyAirports.find((a) => a.id === e.target.value); if (sel) { setNearestAirport(sel); setResults([]); setStatus(`Airport set to ${sel.id}`); } }} style={s.select}>
                {nearbyAirports.map((a) => <option key={a.id} value={a.id}>{a.id} — {a.name} ({a.dist.toFixed(1)} mi)</option>)}
              </select>
              {airportPhoto && <img src={airportPhoto} alt={nearestAirport?.name} style={s.airportImg} />}
              {nearestAirport && (
                <div style={s.fboCard}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: textPrimary, marginBottom: 8 }}>Airport Resources</div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <a href={`https://www.airnav.com/airport/${nearestAirport.id}`} target="_blank" rel="noreferrer" style={{ ...s.btnLink, display: "inline-block", textDecoration: "none" }}>AirNav</a>
                    <a href={`https://skyvector.com/airport/${nearestAirport.id}`} target="_blank" rel="noreferrer" style={{ ...s.btnLink, display: "inline-block", textDecoration: "none" }}>SkyVector</a>
                    <a href={`https://www.airnav.com/airport/${nearestAirport.id}#services`} target="_blank" rel="noreferrer" style={{ ...s.btnLink, display: "inline-block", textDecoration: "none" }}>FBO Info</a>
                  </div>
                </div>
              )}
<div style={{ fontSize: 12, color: textSecondary, marginTop: 8, marginBottom: 6 }}>Not listed? Enter airport ID:</div>
              <div style={{ fontSize: 11, color: textSecondary, marginBottom: 6, opacity: 0.7 }}>Try 3-letter (S43) or 4-letter ICAO (KSEA, K0S9)</div>              <div style={{ display: "flex", gap: 8 }}>
                <input style={{ ...s.input, flex: 1 }} placeholder="e.g. KGEG" value={manualAirport} onChange={(e) => setManualAirport(e.target.value)} />
                <button style={s.btnSmall} onClick={handleManualAirport}>Set</button>
              </div>
            </div>
          )}

          <div style={s.card}>
            <div style={s.row}>
              <div><label style={s.label}>Time available</label>
                <select value={availableTime} onChange={(e) => setAvailableTime(Number(e.target.value))} style={s.select}>
                  {TIME_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
              <div><label style={s.label}>Meal duration</label>
                <select value={mealTime} onChange={(e) => setMealTime(Number(e.target.value))} style={s.select}>
                  {MEAL_TIME_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
            </div>
            <div style={s.row}>
              <div><label style={s.label}>Cuisine</label>
                <select value={cuisineFilter} onChange={(e) => setCuisineFilter(e.target.value)} style={s.select}>
                  {CUISINES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
              </div>
              <div><label style={s.label}>Sort by</label>
                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} style={s.select}>
                  {SORT_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                </select>
              </div>
            </div>
            <label style={s.label}>Max distance — {maxMiles} miles</label>
            <input type="range" min={1} max={20} step={1} value={maxMiles} onChange={(e) => setMaxMiles(Number(e.target.value))} style={{ width: "100%", accentColor: "#1a4a7a" }} />
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11, color: textSecondary, marginTop: 2 }}><span>1 mi</span><span>20 mi</span></div>
          </div>

          <button onClick={detectLocation} style={s.btnSecondary}>{locFound ? "Re-detect location" : "Detect my location"}</button>
          <button onClick={findOptions} disabled={loading} style={{ ...s.btnPrimary, ...(loading ? { background: "#b0bec5", cursor: "not-allowed" } : {}) }}>
            {loading ? "Searching..." : "Find best options"}
          </button>

          {!isPro && !loading && results.length === 0 && (
            <div style={{ ...s.card, background: "linear-gradient(135deg, #0f2a4a11 0%, #1a4a7a11 100%)", border: "1px solid #1a4a7a44", textAlign: "center", padding: "1rem" }}>
              <div style={{ fontSize: 13, color: textPrimary, marginBottom: 8 }}>Unlock pilot notes, crew car info, FBO intel, and favorites</div>
              <button style={{ ...s.btnPro, marginBottom: 0 }} onClick={handleUpgrade}>Upgrade to Pro — $4.99/month</button>
            </div>
          )}

          {status && <div style={s.status}>{status}</div>}

{noRestaurants && (
            <div style={{ ...s.resultCard, borderLeft: "4px solid #6b7a90", padding: "1rem 1.25rem" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: textPrimary }}>{nearestAirport?.id} — {nearestAirport?.name}</div>
                  <div style={{ fontSize: 12, color: textSecondary, marginTop: 3 }}>Remote or rural airport</div>
                </div>
                <span style={{ fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 100, background: "#e9ecef", color: "#495057" }}>Restaurant N/A</span>
              </div>
              <div style={{ fontSize: 13, color: textSecondary, marginTop: 10, paddingTop: 10, borderTop: `1px solid ${borderColor}` }}>
                No restaurants found within {maxMiles} miles. Try increasing the distance slider, or this may be a backcountry/remote strip with no nearby services.
              </div>
              {nearestAirport && (
                <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                  <a href={`https://www.airnav.com/airport/${nearestAirport.id}`} target="_blank" rel="noreferrer" style={{ ...s.btnLink, display: "inline-block", textDecoration: "none" }}>AirNav</a>
                  <a href={`https://skyvector.com/airport/${nearestAirport.id}`} target="_blank" rel="noreferrer" style={{ ...s.btnLink, display: "inline-block", textDecoration: "none" }}>SkyVector</a>
                </div>
              )}
            </div>
          )}
{cuisineFilter !== "any" && results.length > 0 && sortedResults.length === 0 && (
            <div style={{ ...s.status, borderLeft: `3px solid ${borderColor}` }}>
              No {CUISINES.find(c => c.value === cuisineFilter)?.label} restaurants found in these results. Try switching to <strong>Any</strong> cuisine or increasing the distance.
            </div>
          )}
          {sortedResults.length > 0 && <div style={{ fontSize: 10, fontWeight: 700, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Results — {sortedResults.length} options</div>}          {sortedResults.map((r, i) => (
            <div key={i} style={i === 0 ? s.resultCardTop : s.resultCard}>
              {i === 0 && <div style={{ fontSize: 10, fontWeight: 700, color: "#1a4a7a", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Best option</div>}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: textPrimary }}>{favorites.includes(r.name) ? "★ " : ""}{r.name}</div>
                  <div style={{ fontSize: 12, color: textSecondary, marginTop: 2 }}>
                    {r.cuisine || "Restaurant"} · {r.driveMiles} mi by road
                    {r.openNow !== null && <span style={s.openBadge(r.openNow)}>{r.openNow ? "Open" : "Closed"}</span>}
                  </div>
                </div>
                <span style={{ fontSize: 10, fontWeight: 700, padding: "4px 10px", borderRadius: 100, whiteSpace: "nowrap", marginLeft: 8, ...verdictColors[r.verdict] }}>{r.verdict}</span>
              </div>
              <div style={s.statsRow}>
                <div><span style={s.statValue}>{r.driveMin} min</span><span style={s.statLabel}>drive</span></div>
                <div><span style={s.statValue}>{r.driveMin * 2} min</span><span style={s.statLabel}>round trip</span></div>
                <div><span style={{ ...s.statValue, color: r.buffer < 0 ? "#c0392b" : r.buffer < 10 ? "#c68000" : "#1a5c2a" }}>{r.buffer > 0 ? `+${r.buffer}` : r.buffer} min</span><span style={s.statLabel}>buffer</span></div>
              </div>
              {expandedResult === i && (
                <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${borderColor}` }}>
                  {r.phone && <div style={s.detailRow}>📞 <a href={`tel:${r.phone}`} style={{ color: "#1a4a7a" }}>{r.phone}</a></div>}
                  {r.hours && (
                    <div style={{ marginTop: 6 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: textSecondary, marginBottom: 4 }}>HOURS</div>
                      {r.hours.map((h, idx) => <div key={idx} style={{ fontSize: 12, color: textSecondary }}>{h}</div>)}
                    </div>
                  )}
                </div>
              )}
              <div style={s.actionRow}>
                <button style={s.btnSmall} onClick={() => openInMaps(r)}>Navigate</button>
                <button style={s.btnSmall} onClick={() => openGoogleMapsPage(r)}>Details</button>
                <button style={s.btnSmall} onClick={() => setExpandedResult(expandedResult === i ? null : i)}>{expandedResult === i ? "Less" : "Hours"}</button>
                <button style={s.btnSmall} onClick={() => toggleFavorite(r.name)}>{favorites.includes(r.name) ? "Unfavorite" : "Favorite"}</button>
                <button style={s.btnSmall} onClick={() => shareResult(r)}>Share</button>
              </div>
            </div>
          ))}
        </>
      )}

      {activeTab === "notes" && (
        <>
          {!isPro ? <ProWall feature="Pilot notes" /> : (
            <>
              <div style={s.subTabs}>
                {[{ label: "General", value: "general" }, { label: "Crew Car", value: "crewcar" }, { label: "FBO", value: "fbo" }].map((t) => (
                  <button key={t.value} style={{ ...s.subTab, ...(notesSubTab === t.value ? s.subTabActive : {}) }} onClick={() => setNotesSubTab(t.value)}>{t.label}</button>
                ))}
              </div>
              <div style={s.card}>
                <div style={{ fontSize: 13, fontWeight: 700, color: textPrimary, marginBottom: 6 }}>
                  {notesSubTab === "general" && `Pilot notes — ${nearestAirport?.id || "select airport"}`}
                  {notesSubTab === "crewcar" && `Crew cars — ${nearestAirport?.id || "select airport"}`}
                  {notesSubTab === "fbo" && `FBO info — ${nearestAirport?.id || "select airport"}`}
                </div>
                {notesSubTab === "crewcar" && <div style={{ fontSize: 12, color: textSecondary, marginBottom: 10 }}>Share crew car availability, FBO name, key required, hours, first come first served, etc.</div>}
                {notesSubTab === "fbo" && <div style={{ fontSize: 12, color: textSecondary, marginBottom: 10 }}>Share FBO services, fuel prices, ramp fees, handling notes, and contact info.</div>}
                <div style={{ fontSize: 12, color: textSecondary, marginBottom: 8 }}>Posting as {user?.displayName}</div>
                <textarea style={{ ...s.input, height: 70, resize: "vertical", marginBottom: 8 }}
                  placeholder={notesSubTab === "crewcar" ? "e.g. Crew car available at Hillsboro Aviation, key at front desk..." : notesSubTab === "fbo" ? "e.g. Cascade FBO — friendly staff, $1.20 ramp fee waived with 10gal purchase..." : "Share local knowledge — parking, restaurants, tips..."}
                  value={newNote} onChange={(e) => setNewNote(e.target.value)} />
                {photoPreview && <img src={photoPreview} alt="preview" style={s.photoPreviewImg} />}
                <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                  <button style={{ ...s.btnSmall, flex: 1 }} onClick={() => fileInputRef.current?.click()}>Add photo</button>
                  {photoFile && <button style={s.btnDanger} onClick={() => { setPhotoFile(null); setPhotoPreview(null); }}>Remove</button>}
                </div>
                <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handlePhotoSelect} />
                <button style={{ ...s.btnPrimary, marginBottom: 0 }} onClick={addNote} disabled={uploadingPhoto}>{uploadingPhoto ? "Posting..." : "Post note"}</button>
              </div>
              <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
                {NOTE_FILTERS.map((f) => (
                  <button key={f.value} style={{ ...s.btnSmall, flex: 1, background: noteFilter === f.value ? "#1a4a7a" : cardBg, color: noteFilter === f.value ? "white" : textSecondary, border: noteFilter === f.value ? "none" : `1px solid ${borderColor}` }} onClick={() => setNoteFilter(f.value)}>{f.label}</button>
                ))}
              </div>
              {sortedNotes.length === 0 && <div style={{ fontSize: 13, color: textSecondary, textAlign: "center", padding: "2rem 0" }}>No notes yet. Be the first.</div>}
              {sortedNotes.map((n) => (
                <div key={n.id} style={s.noteCard}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                    <div style={s.noteMeta}>{n.author} · {n.time}</div>
                    {user && n.uid === user.uid && <button style={s.btnDanger} onClick={() => deleteNote(n.id)}>Delete</button>}
                  </div>
                  {n.text && <div style={s.noteText}>{n.text}</div>}
                  {n.photoURL && <img src={n.photoURL} alt="note" style={s.notePhoto} />}
                  <div style={s.noteActions}>
                    <button style={s.btnLike(n.likedByMe)} onClick={() => likeNote(n.id)}>♥ {n.likes || 0}</button>
                    <button style={s.btnSmall} onClick={() => setReplyingTo(replyingTo === n.id ? null : n.id)}>Reply</button>
                    <button style={s.btnSmall} onClick={() => { const show = !expandedReplies[n.id]; setExpandedReplies((prev) => ({ ...prev, [n.id]: show })); if (show) loadReplies(nearestAirport.id, n.id); }}>{expandedReplies[n.id] ? "Hide replies" : "Replies"}</button>
                    <button style={{ ...s.btnSmall, marginLeft: "auto" }} onClick={() => reportNote(n.id)}>Report</button>
                  </div>
                  {replyingTo === n.id && (
                    <div style={{ marginTop: 8 }}>
                      <input style={{ ...s.input, marginBottom: 6 }} placeholder="Write a reply..." value={replyText} onChange={(e) => setReplyText(e.target.value)} />
                      <div style={{ display: "flex", gap: 6 }}>
                        <button style={{ ...s.btnSmall, flex: 1 }} onClick={() => addReply(n.id)}>Post reply</button>
                        <button style={s.btnSmall} onClick={() => setReplyingTo(null)}>Cancel</button>
                      </div>
                    </div>
                  )}
                  {expandedReplies[n.id] && noteReplies[n.id] && (
                    <div style={{ marginTop: 8 }}>
                      {noteReplies[n.id].length === 0 && <div style={{ fontSize: 12, color: textSecondary }}>No replies yet.</div>}
                      {noteReplies[n.id].map((r, i) => (
                        <div key={i} style={s.replyCard}>
                          <div style={s.replyMeta}>{r.author} · {r.time}</div>
                          <div style={s.replyText}>{r.text}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
        </>
      )}

      {activeTab === "history" && (
        <>
          <div style={{ fontSize: 10, fontWeight: 700, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Recent searches</div>
          {!isPro ? <ProWall feature="Search history" /> : (
            history.length === 0 ? <div style={{ fontSize: 13, color: textSecondary, textAlign: "center", padding: "2rem 0" }}>No history yet.</div>
            : history.map((h, i) => (
              <div key={i} style={s.historyItem}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: textPrimary }}>{h.airport}</div>
                  <div style={{ fontSize: 12, color: textSecondary }}>{h.results} results · {h.time}</div>
                </div>
              </div>
            ))
          )}
        </>
      )}

      {activeTab === "favorites" && (
        <>
          <div style={{ fontSize: 10, fontWeight: 700, color: textSecondary, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>Starred restaurants</div>
          {!isPro ? <ProWall feature="Favorites" /> : (
            favorites.length === 0 ? <div style={{ fontSize: 13, color: textSecondary, textAlign: "center", padding: "2rem 0" }}>No favorites yet. Star a restaurant from search results.</div>
            : favorites.map((name, i) => (
              <div key={i} style={s.historyItem}>
                <div style={{ fontWeight: 700, fontSize: 14, color: textPrimary }}>★ {name}</div>
                <button style={s.btnSmall} onClick={() => toggleFavorite(name)}>Remove</button>
              </div>
            ))
          )}
        </>
      )}
    </div>
  );
}